export default {
  common_share: `แชร์`,
  common_share_short: `แชร์`,
  common_notice: `ประกาศ`,
  common_notification: `แจ้งเตือน`,
  common_download: `ดาวน์โหลด`,
  common_download_plural: `ดาวน์โหลด`,
  common_update: `อัปเดต`,
  common_update_now: `อัปเดตตอนนี้`,
  common_cancel: `ยกเลิก`,
  common_close: `ปิด`,
  common_ok: `ตกลง`,
  common_confirm: `ตกลง`,
  common_yes: `ใช่`,
  common_no: `ไม่`,
  common_save: `บันทึก`,
  common_error_retry: `ลองใหม่`,
  common_login: `เข้าสู่ระบบ`,
  common_logout: `ออกจากระบบ`,
  common_copy: `คัดลอก`,
  common_refresh: `รีเฟรช`,
  common_delete: `ลบ`,
  common_fix: `แก้ไข`,
  common_service_version: `เวอร์ชั่นบริการ`,
  common_edit: `แก้ไข`,
  common_language: `ภาษา`,
  common_language_english: `English`,
  common_language_korean: `한국어`,
  common_language_zh_hant: `繁體中文`,
  common_language_thai: `ภาษาไทย`,
  common_language_indonesia: `Bahasa Indonesia`,
  common_language_french: `Français`,
  common_content_season: `ซีซั่น`,
  common_content_season_plural: `ซีซั่น`,
  common_content_episode: `ตอนที่`,
  common_content_episode_plural: `ตอนที่`,
  common_content_episode_value_short: `ตอนที่ {{value}}`,
  common_episode_count: `{{count}} ตอน`,
  common_episode_count_plural: `{{count}} ตอน`,
  common_content_favorite: `ติดตาม`,
  common_content_tag: `แท็ก`,
  common_content_like: `ถูกใจ`,
  common_content_like_plural: `ถูกใจ`,
  common_universe: `Universe`,
  common_universe_circle: `Universe Circle`,
  common_viewer_alive: `ALIVE viewer`,
  common_matching_ai: `จับคู่โดย AI`,
  common_matching_special: `จับคู่พิเศษ`,
  common_free: `ฟรี`,
  common_paid: `เปย์`,
  common_rental: `เช่า`,
  common_gidamu: `รออ่านฟรี`,
  common_gidamu_plus: `{{value}}ชม.`,
  common_gidamu_plus_long: `รอฟรี {{value}}ชม.`,
  common_ongoing_free: `ฟรี`,
  common_free_available: `อ่านฟรีได้`,
  common_now_charging: `กำลังชาร์จตั๋วรออ่านฟรี`,
  common_tab_library: `ชั้นหนังสือ`,
  common_tab_ranking: `อันดับ`,
  common_tab_giftbox: `กล่องของขวัญ`,
  common_tab_service_name: `KAKAO WEBTOON`,
  common_tab_time_table_global: `ตารางเว็บตูน`,
  common_tab_gidamu_plus: `รอฟรี +`,
  common_cash: `แคช`,
  common_cash_amount: `{{value}} แคช`,
  common_cash_currency: `฿ {{value}}`,
  common_cash_currency_symbol: `฿`,
  common_ticket_amount: `{{count}} ตั๋ว`,
  common_ticket_amount_plural: `{{count}} ตั๋ว`,
  common_cash_purchased: `แคชที่เติม`,
  common_cash_gift: `แคชของขวัญ`,
  common_ticket: `ตั๋ว`,
  common_ticket_plural: `ตั๋ว`,
  common_ticket_possession: `ตั๋วซื้อเก็บ`,
  common_ticket_possession_plural: `ตั๋วซื้อเก็บ`,
  common_ticket_possession_amount: `{{count}} ตั๋วซื้อเก็บ`,
  common_ticket_possession_amount_plural: `{{count}} ตั๋วซื้อเก็บ`,
  common_ticket_rental: `ตั๋วเช่า`,
  common_ticket_rental_plural: `ตั๋วเช่า`,
  common_ticket_rental_amount: `{{count}} ตั๋วเช่า`,
  common_ticket_rental_amount_plural: `{{count}} ตั๋วเช่า`,
  common_ticket_gift: `ตั๋วของขวัญ`,
  common_ticket_gift_plural: `ตั๋วของขวัญ`,
  common_ticket_gift_amount: `{{count}} ตั๋วของขวัญ`,
  common_ticket_gift_amount_plural: `{{count}} ตั๋วของขวัญ`,
  common_ticket_gidamu: `ตั๋วรออ่านฟรี`,
  common_ticket_gidamu_plural: `ตั๋วรออ่านฟรี`,
  common_ticket_gidamu_amount: `{{count}} ตั๋วรออ่านฟรี`,
  common_ticket_gidamu_amount_plural: `{{count}} ตั๋วรออ่านฟรี`,
  common_expired: `หมดอายุ`,
  common_add: `เติม`,
  common_purchase: `แลก`,
  common_refund: `คืน`,
  common_refund_past: `คืนสำเร็จ`,
  common_use: `ใช้`,
  common_use_past: `ใช้แล้ว`,
  common_purchased: `ซื้อเก็บแล้ว`,
  common_crm_slot_ticket: `สล็อตแมชชีน`,
  common_crm_slot_ticket_plural: `สล็อตแมชชีน`,
  common_crm_reservation: `กดติดตาม`,
  common_bm_gidamu: `รออ่านฟรี`,
  common_bm_preview: `อ่านล่วงหน้า`,
  common_genre_all: `ทั้งหมด`,
  common_genre_romance: `โรแมนซ์`,
  common_genre_romance_fantasy: `โรแมนซ์ แฟนตาซี`,
  common_genre_comedy: `ตลก/ชีวิตประจำวัน`,
  common_genre_action: `แอ็กชัน/กำลังภายใน`,
  common_genre_fantasy: `แฟนตาซี`,
  common_genre_thriller_horror: `ระทึกขวัญ/สยองขวัญ`,
  common_genre_bl: `วาย`,
  common_genre_drama: `ดราม่า`,
  common_schedule_daily: `รายวัน`,
  common_schedule_new: `ใหม่`,
  common_schedule_mon: `จ.`,
  common_schedule_tue: `อ.`,
  common_schedule_wed: `พ.`,
  common_schedule_thu: `พฤ.`,
  common_schedule_fri: `ศ.`,
  common_schedule_sat: `ส.`,
  common_schedule_sun: `อา.`,
  common_schedule_completed: `จบ`,
  common_time_year_ago: `{{count}} ปีที่แล้ว`,
  common_time_year_ago_plural: `{{count}} ปีที่แล้ว`,
  common_time_month_ago: `{{count}} เดือนที่แล้ว`,
  common_time_month_ago_plural: `{{count}} เดือนที่แล้ว`,
  common_time_day_ago: `{{count}} วันที่แล้ว`,
  common_time_day_ago_plural: `{{count}} วันที่แล้ว`,
  common_time_hour_ago: `{{count}} ชม. ที่แล้ว`,
  common_time_hour_ago_plural: `{{count}} ชม. ที่แล้ว`,
  common_time_minute_ago: `{{count}} น. ที่แล้ว`,
  common_time_minute_ago_plural: `{{count}} น. ที่แล้ว`,
  common_time_second_ago: `เมื่อสักครู่`,
  common_now: `ตอนนี้`,
  common_period_year: `{{count}} ปี`,
  common_period_year_plural: `{{count}} ปี`,
  common_period_month: `{{count}} เดือน`,
  common_period_month_plural: `{{count}} เดือน`,
  common_period_day: `{{count}} วัน`,
  common_period_day_plural: `{{count}} วัน`,
  common_period_hour: `{{count}} ชม.`,
  common_period_hour_plural: `{{count}} ชม.`,
  common_period_minute: `{{count}} น.`,
  common_period_minute_plural: `{{count}} น.`,
  common_period_year_short: `{{count}} ปี`,
  common_period_year_short_plural: `{{count}} ปี`,
  common_period_month_short: `{{count}} เดือน`,
  common_period_month_short_plural: `{{count}} เดือน`,
  common_period_day_short: `{{count}} วัน`,
  common_period_day_short_plural: `{{count}} วัน`,
  common_period_hour_short: `{{count}} ชม.`,
  common_period_hour_short_plural: `{{count}} ชม.`,
  common_period_minute_short: `{{count}} น.`,
  common_period_minute_short_plural: `{{count}} น.`,
  common_period_second_short: `{{count}} วิ.`,
  common_period_second_short_plural: `{{count}} วิ.`,
  common_time_left: `เหลืออีก {{value}}`,
  common_time_ago: `{{value}} ที่แล้ว`,
  common_stroage_kb: `{{value}} KB`,
  common_stroage_mb: `{{value}} MB`,
  common_stroage_gb: `{{value}} GB`,
  common_service_name: `KAKAO WEBTOON`,
  common_not_select: `ไม่ตั้งค่า`,
  common_kakaowebtoon: `KAKAO WEBTOON`,
  common_tab_home: `หน้าแรก`,
  recomm_tab_recommendations: `แนะนำ`,
  recomm_tab_special: `พิเศษ`,
  recomm_tab_gidamu: `รอฟรี +`,
  recomm_top_100: `TOP 100`,
  recomm_tab_gidamu_description: `ทุกๆ {{hour}} ชม. แจก <grey-bold> ตั๋วรออ่านฟรี </grey-bold> ไปสนุกกันได้เร็วกว่าเดิม!`,
  recomm_label_gidamu: `ฟรีทุกๆ {{value}} ชม.`,
  top_guide_popup: `แจ้งเตือนรออ่านฟรี
สามารถเช็กได้ที่นี่`,
  recomm_label_popular: `ยอดนิยม`,
  recomm_label_completed_nearly: `ใกล้จบบริบูรณ์`,
  recomm_label_completed_nearly_detail: `มีแผนว่าจะจบบริบูรณ์`,
  recomm_label_upcoming: `เร็วๆ นี้`,
  recomm_label_trailer: `Movie Trailer`,
  recomm_label_original_movie: `Movie Original`,
  recomm_label_original_drama: `Drama Original`,
  recomm_label_event: `กิจกรรม`,
  recomm_label_event_detail_gift: `แคชของขวัญ`,
  recomm_label_event_detail_max: `แจกสูงสุด`,
  recomm_label_ticket_detail: `{{value}} ตั๋ว`,
  recomm_label_ticket_detail_v4: `แจก {{value}} ตั๋ว`,
  recomm_label_ticket_detail_gift: `ตั๋วของขวัญ`,
  recomm_label_legend: `ตำนาน`,
  recomm_label_new_detail: `ยอดอ่าน`,
  recomm_label_popular_detail: `ยอดอ่านสะสม`,
  recomm_label_recommendation: `จับคู่โดยAI `,
  common_tab_top: `HOME`,
  common_tab_hot: `กำลังฮิต`,
  ranking_tab_weekly: `ประจำสัปดาห์`,
  ranking_tab_daily: `ประจำวัน`,
  ranking_tab_real_time: `เรียลไทม์`,
  ranking_in_progress: `กำลังประมวลผลอันดับ`,
  ranking_badge_new: `NEW`,
  ranking_criteria_popup_title: `(번역 필요)`,
  ranking_criteria_popup_contents: `(번역 필요)`,
  common_tab_category: `คลังเว็บตูน`,
  category_tab_ranking: `อันดับ`,
  category_tab_ranking_weekly: `ประจำสัปดาห์`,
  category_tab_ranking_daily: `ประจำวัน`,
  category_tab_ranking_real_time: `เรียลไทม์`,
  category_tab_ranking_in_progress: `กำลังประมวลผลอันดับ`,
  category_tab_ranking_badge_new: `NEW`,
  category_tab_new: `ใหม่`,
  category_tab_ongoing: `Ongoing`,
  category_tab_completed: `จบ`,
  common_tab_original_webtoon: `Webtoon Original`,
  common_tab_original_novel: `Novel Original`,
  schedule_new_today: `วันนี้`,
  schedule_genre_filter_all: `ทั้งหมด`,
  schedule_monday: `วันจันทร์`,
  schedule_tuesday: `วันอังคาร`,
  schedule_wednesday: `วันพุธ`,
  schedule_thursday: `วันพฤหัส`,
  schedule_friday: `วันศุกร์`,
  schedule_saturday: `วันเสาร์`,
  schedule_sunday: `วันอาทิตย์`,
  schedule_empty: `ไม่มีผลงาน`,
  schedule_completed_label_legend: `ตำนาน`,
  schedule_completed_label_pd: `แนะนำโดย PD`,
  schedule_completed_label_trailer: `ตัวอย่างภาพยนตร์`,
  schedule_completed_label_recommendation: `แนะนำ`,
  schedule_completed_label_magazine: `แม็กกาซีน`,
  schedule_completed_label_cashback: `แคชแบ็ก`,
  schedule_two_column: `2 แถว`,
  schedule_three_column: `3 แถว`,
  schedule_four_column: `4 แถว`,
  schedule_two_column_selected: `ดูเป็น 2 แถว`,
  schedule_three_column_selected: `ดูเป็น 3 แถว`,
  schedule_four_column_selected: `ดูเป็น 4 แถว`,
  schedule_sort_guide: `จัดการเรื่องที่กำลังอัปเดตในแต่ละวัน
จัดเรียงลำดับตามที่คุณต้องการได้`,
  schedule_guide_popup: `คุณสามารถเปลี่ยนลำดับและประเภทของรายการได้`,
  schedule_sort_title: `เรียงลำดับ`,
  schedule_sort_recommend: `แนะนำ`,
  schedule_sort_early_access: `จำนวนตอนฟรี`,
  schedule_sort_gidamu: `จำนวนตอนรออ่านฟรี`,
  schedule_sort_gidamu_short: `ระยะเวลารออ่านฟรี`,
  schedule_sort_not_provided_toast: `ขณะนี้ คุณสามารถจัดเรียงตามแนะนำได้เท่านั้น`,
  schedule_genre_select_popup: `เลือกประเภท`,
  login_action_view_next_episode_popup: `กรุณาเข้าสู่ระบบ
เพื่ออ่านตอนต่อไป`,
  contenthome_wifi_popup: `คุณไม่ได้ใช้ Wi-Fi อยู่ในตอนนี้ ซึ่งอาจมีค่าบริการเพิ่มเติมจากการใช้เซลลูลาร์ดาต้า
หากต้องการเปิดอ่านด้วย Wi-Fi กรุณาเปิดที่ ตั้งค่า > ตั้งค่าข้อมูล`,
  contenthome_ticketused_possession_snackbar: `ใช้ {{value}} ตั๋วซื้อเก็บแล้ว`,
  contenthome_ticketused_rental_snackbar: `ใช้ {{value}} ตั๋วเช่าแล้ว`,
  contenthome_ticketused_gift_snackbar: `ใช้ {{value}} ตั๋วของขวัญแล้ว`,
  contenthome_ticketused_gidamu_snackbar: `ใช้ {{value}} ตั๋วรออ่านฟรีแล้ว`,
  contenthome_ticket_option_popup: `กรุณาเลือกตั๋วที่จะใช้`,
  contenthome_popup_rent_button: `ตั๋วเช่า`,
  contenthome_popup_possess_button: `ตั๋วซื้อเก็บ`,
  contenthome_ticket_remaining: `ตั๋วเช่า: {{rental}} ตั๋ว / ตั๋วซื้อเก็บ: {{possess}} ตั๋ว`,
  contenthome_ticket_remaining_rental_plural: `ตั๋วเช่า: {{rental}} ตั๋ว / ตั๋วซื้อเก็บ: {{possess}} ตั๋ว`,
  contenthome_ticket_remaining_possession_plural: `ตั๋วเช่า: {{rental}} ตั๋ว / ตั๋วซื้อเก็บ: {{possess}} ตั๋ว`,
  contenthome_ticket_remaining_plural: `ตั๋วเช่า: {{rental}} ตั๋ว / ตั๋วซื้อเก็บ: {{possess}} ตั๋ว`,
  contenthome_popup_ticket_rental: `ตั๋วเช่า: {{count}} ตั๋ว`,
  contenthome_popup_ticket_rental_plural: `ตั๋วเช่า: {{count}} ตั๋ว`,
  contenthome_popup_ticket_possession: `ตั๋วซื้อเก็บ: {{count}} ตั๋ว`,
  contenthome_popup_ticket_possession_plural: `ตั๋วซื้อเก็บ: {{count}} ตั๋ว`,
  contenthome_latest_ep_ticket_popup: `ไม่สามารถใช้ตั๋วรออ่านฟรี
กับ {{value}} ตอนล่าสุดได้
ต้องการใช้ตั๋วชนิดอื่นหรือไม่?`,
  contenthome_latest_ep_ticket_rental_popup: `ไม่สามารถใช้ตั๋วรออ่านฟรี
กับ {{value}} ตอนล่าสุดได้
ต้องใช้ตั๋วเช่าเท่านั้น`,
  contenthome_latest_ep_ticket_possession_popup: `ไม่สามารถใช้ตั๋วรออ่านฟรี
กับ {{value}} ตอนล่าสุดได้
ต้องการใช้ตั๋วซื้อเก็บหรือไม่?`,
  contenthome_not_gidamu_ep_ticket_popup: `ไม่ใช่ตอนที่สามารถใช้ตั๋วรออ่านฟรีได้
ต้องการใช้ตั๋วชนิดอื่นหรือไม่?`,
  contenthome_not_gidamu_ep_ticket_rental_popup: `ไม่ใช่ตอนที่สามารถใช้ตั๋วรออ่านฟรีได้
ตั๋วเช่าจะถูกใช้`,
  contenthome_not_gidamu_ep_ticket_possession_popup: `ไม่ใช่ตอนที่สามารถใช้ตั๋วรออ่านฟรีได้
ตั๋วซื้อเก็บจะถูกใช้`,
  contenthome_rented_ep_ticket_rental_popup: `คุณเคยเปิดอ่านตอนนี้แล้ว
ใช้ตั๋วเช่าอีกครั้งหรือไม่?`,
  contenthome_rented_ep_ticket_possession_popup: `คุณเคยเปิดอ่านตอนนี้แล้ว
ใช้ตั๋วซื้อเก็บอีกครั้งหรือไม่?`,
  contenthome_rented_ep_ticket_gift_popup: `คุณเคยเปิดอ่านตอนนี้แล้ว
ใช้ตั๋วของขวัญอีกครั้งหรือไม่?`,
  contenthome_rented_ep_ticket_gidamu_popup: `คุณเคยเปิดอ่านตอนนี้แล้ว
ใช้ตั๋วรออ่านฟรีอีกครั้งหรือไม่?`,
  contenthome_rented_ep_ticket_popup: `คุณเคยเปิดอ่านตอนนี้แล้ว
ต้องการใช้ตั๋วหรือไม่?`,
  contenthome_rented_ep_purchase_ticket_popup: `คุณเคยเปิดอ่านตอนนี้แล้ว
ต้องการไปแลกตั๋วเพื่อเปิดอ่านหรือไม่?`,
  contenthome_expired_popup: `ไม่สามารถอ่านได้เนื่องจากหมดอายุการเช่า
กรุณาเลือกตอนที่จะอ่าน`,
  contenthome_expired_popup_viewed_button: `ตอนที่เคยอ่าน`,
  contenthome_expired_popup_next_button: `ตอนต่อไป`,
  contenthome_latest_expired_ticket_rental_popup: `ไม่สามารถใช้ตั๋วรออ่านฟรีได้
กับ {{value}} ตอนล่าสุดที่มีประวัติการอ่าน
ต้องใช้ตั๋วเช่าเท่านั้น`,
  contenthome_latest_expired_ticket_possession_popup: `ไม่สามารถใช้ตั๋วรออ่านฟรีได้
กับ {{value}} ตอนล่าสุดที่มีประวัติการอ่าน
ต้องการใช้ตั๋วซื้อเก็บหรือไม่?`,
  contenthome_latest_expired_ticket_popup: `ไม่สามารถใช้ตั๋วรออ่านฟรีได้
กับ {{value}} ตอนล่าสุดที่มีประวัติการอ่าน
ต้องการใช้ตั๋วอื่นหรือไม่?`,
  contenthome_stop_sell_popup: `ไม่สามารถอ่านได้ เนื่องจากระงับการจำหน่าย`,
  contenthome_ticketused_gift_popup: `ตั๋วของขวัญจะถูกใช้`,
  contenthome_ticketused_rental_popup: `ตั๋วเช่าจะถูกใช้`,
  contenthome_ticketused_possession_popup: `ตั๋วซื้อเก็บจะถูกใช้`,
  contenthome_ticketused_gidamu_popup: `ตั๋วรออ่านฟรีจะถูกใช้`,
  contenthome_latest_ep_gidamu_popup: `ตอนที่ไม่สามารถใช้ตั๋วรออ่านฟรีได้`,
  contenthome_universe_matching: `{{matching}} รวมถึง {{title}}`,
  contenthome_universe_similar_title: `ผลงานที่คล้ายกัน`,
  contenthome_universe_similar_drawing: `ผลงานที่ลายเส้นคล้ายกัน`,
  contenthome_universe_same_genre: `ผลงานประเภท {{genre}} เหมือนกัน`,
  contenthome_universe_today_popular: `ผลงานที่มีผู้อ่านมากที่สุดในวันนี้`,
  contenthome_universe_today_favorite: `ผลงานที่ผู้ติดตามมากที่สุดในวันนี้`,
  contenthome_gift_rental_popup: `รับ {{count}} ตั๋วของขวัญแล้ว`,
  contenthome_gift_rental_popup_plural: `รับ {{count}} ตั๋วของขวัญแล้ว`,
  contenthome_gift_rental_valid_until_popup: `หมดอายุ: 3 วัน นับจากวันที่แจก`,
  contenthome_expiry_specific_date: `หมดอายุ: จนถึง {{value}}`,
  contenthome_fav_notification_popup_title: `เพิ่มในผลงานที่ติดตามแล้ว`,
  contenthome_fav_notification_popup_content: `รับการแจ้งเตือนเมื่อผลงานมีอัปเดต
ตั้งค่าได้ที่ 'ชั้นหนังสือ > ผลงานที่ติดตาม'`,
  contenthome_fav_undo_toast: `เลิกติดตามแล้ว`,
  contenthome_ticketbar_ticket: `{{count}} ตั๋ว`,
  contenthome_ticketbar_ticket_plural: `{{count}} ตั๋ว`,
  contenthome_ticketbar_newbie_ticket: `{{count}} ตั๋วสิทธิประโยช์ผู้ใช้ใหม่`,
  contenthome_ticketbar_newbie_ticket_plural: `{{count}} ตั๋วสิทธิประโยช์ผู้ใช้ใหม่`,
  contenthome_ticketbar_gidamu: `ฟรีทุกๆ {{count}} วัน`,
  contenthome_ticketbar_gidamu_plural: `ฟรีทุกๆ {{count}} วัน`,
  contenthome_ticketbar_gidamu_hour: `ฟรีทุกๆ {{count}} ชม.`,
  contenthome_ticketbar_gidamu_hour_plural: `ฟรีทุกๆ {{count}} ชม.`,
  contenthome_ticketbar_gidamu_minute: `ฟรีทุกๆ {{count}} นาที`,
  contenthome_ticketbar_gidamu_minute_plural: `ฟรีทุกๆ {{count}} นาที`,
  contenthome_ticketbar_gidamu_full: `ชาร์จตั๋วรออ่านฟรีสำเร็จ`,
  contenthome_ticketbar_ep_free: `มีตอนฟรี {{count}} ตอน`,
  contenthome_ticketbar_ep_free_plural: `มีตอนฟรี {{count}} ตอน`,
  contenthome_ticketbar_all_free: `ฟรีทั้งหมด`,
  contenthome_ticketbar_charged: `ตั๋วรออ่านฟรี 1 ตั๋ว ชาร์จสำเร็จ`,
  contenthome_ticketbar_charging: `อ่านฟรีได้หลัง {{value}}`,
  contenthome_ticketbar_preview: `อ่านล่วงหน้า {{count}} ตอน`,
  contenthome_ticketbar_preview_plural: `อ่านล่วงหน้า {{count}} ตอน`,
  contenthome_ticketbar_unavailable: `ยกเลิกการขาย`,
  contenthome_guide_popup: `ปัดไปทางซ้ายจะพบผลงานที่จับคู่ให้
ดึงลงจะพบประเภทกลุ่มที่จับคู่ให้`,
  contenthome_total: `ทั้งหมด`,
  contenthome_first_episode_tab_button: `อ่านตอนแรก`,
  contenthome_first_episode_tab_continue: `อ่านต่อตอนแรก`,
  contenthome_first_episode_tab_guide: `ทบทวนเนื้อหาตอนที่คุณอ่านล่าสุด`,
  contenthome_first_episode_tab_content: `อยากรู้เรื่องราวต่อไปไหม?`,
  contenthome_first_episode_tab_page_only: `ผลงานเรื่องนี้สามารถอ่านได้ในโหมดซ้าย-ขวา
คุณต้องการที่จะเปลี่ยนโหมดไหม?`,
  contenthome_first_episode_tab_paid: `ตอนนี้เป็นตอนเปย์
คุณต้องการใช้ตั๋วเปิดอ่านไหม?`,
  contenthome_first_episode_tab_stop_sell: `ผลงานเรื่องนี้ไม่มีจำหน่ายแล้ว`,
  contenthome_first_episode_tab_related_novel: `นิยายที่เกี่ยวข้องกับเรื่องนี้`,
  contenthome_first_episode_tab_viewer: `เปิดอ่านตอนแบบเต็ม`,
  contenthome_continue_episode_tab_last_read: `ตอนนี้เคยเปิดอ่าน {{value}} `,
  contenthome_continue_episode_tab_last_episode: `ไม่มีตอนต่อไป`,
  contenthome_continue_episode_tab_stop_sell: `ตอนนี้ไม่มีจำหน่ายแล้ว`,
  contenthome_continue_next_episode: `อ่านต่อตอนที่ {{value}}`,
  contenthome_continue_last_episode: `ยังไม่มีตอนต่อไป`,
  contenthome_episode_tab_button: `ตอนที่`,
  contenthome_preview_day: `ฟรีในอีก {{count}} วัน`,
  contenthome_preview_day_plural: `ฟรีในอีก {{count}} วัน`,
  contenthome_ep_tab_order_latest_snackbar: `เรียงจากตอนล่าสุด`,
  contenthome_ep_tab_order_chronological_snackbar: `เรียงจากตอนแรก`,
  contenthome_ep_tab_first_episode_button: `อ่านตอนแรก`,
  contenthome_ep_tab_continue_episode_button: `อ่านต่อตอนที่ {{value}}`,
  contenthome_ep_tab_continue_without_episode_button: `อ่านต่อ`,
  contenthome_ep_tab_back_top_button: `กลับสู่ด้านบน`,
  contenthome_alive_unzipping: `กำลังจัดการไฟล์...`,
  contenthome_alive_download_popup_title: `ALIVE คือวิธีอ่านเว็บตูนรูปแบบใหม่
มาลองสัมผัสความบันเทิงพร้อมเสียงดูสิ`,
  contenthome_storage_full_popup_title: `พื้นที่จัดเก็บของอุปกรณ์ไม่เพียงพอ`,
  contenthome_storage_full_popup_content: `กรุณาจัดการพื้นที่จัดเก็บ แล้วลองใหม่อีกครั้ง`,
  contenthome_alive_fail_unzip_popup_title: `แตกไฟล์ไม่สำเร็จ`,
  contenthome_alive_fail_unzip_popup_content: `กรุณาลองดาวน์โหลดไฟล์อีกครั้ง`,
  contenthome_ep_tab_stop_sell_popup: `ไม่สามารถอ่านได้ เนื่องจากระงับการจำหน่าย`,
  contenthome_ep_expired: `หมดอายุการเช่า`,
  contenthome_ep_tab_type_thumbnail: `ภาพขนาดย่อ`,
  contenthome_ep_tab_type_list: `รายการ`,
  contenthome_ep_tab_order_latest: `เรียงจากตอนล่าสุด`,
  contenthome_ep_tab_order_chronological: `เรียงจากตอนแรก`,
  contenthome_ep_tab_type_thumbnail_toast: `จะแสดงเป็นประเภทภาพขนาดย่อ`,
  contenthome_ep_tab_type_list_toast: `จะแสดงเป็นประเภทรายการ`,
  contenthome_ep_tab_download_guide_popup: `สามารถดาวน์โหลดตอนต่างๆ ได้จากประเภทรายการ`,
  contenthome_ep_tab_type_popup_title: `มีประเภทรายการที่สามารถใช้ได้ทั้
งการดาวน์โหลดและการอ่าน`,
  contenthome_info_tab_button: `ข้อมูล`,
  contenthome_info_tab_author: `เรื่อง`,
  contenthome_info_tab_illustrator: `ภาพ`,
  contenthome_info_tab_original: `ต้นฉบับ`,
  contenthome_info_tab_adaptation: `ดัดแปลง`,
  contenthome_info_tab_color: `สี`,
  contenthome_info_tab_publisher: `เผยแพร่`,
  contenthome_info_tab_summary: `เรื่องย่อ`,
  contenthome_info_tab_more_button: `ดูเพิ่มเติม`,
  contenthome_info_tab_keywords: `คีย์เวิร์ด`,
  contenthome_info_tab_video: `วิดีโอ`,
  contenthome_info_tab_video_v4: `วิดีโอที่เกี่ยวข้อง`,
  contenthome_info_tab_teaser: `Teaser`,
  contenthome_info_tab_special: `Special`,
  contenthome_info_tab_rec_author: `ผลงานอื่นของนักเขียน {{author}}`,
  viewer_end_recommendation: `ผลงานที่คล้ายกัน`,
  contenthome_ticket_tab_button: `ตั๋ว`,
  contenthome_ticket_tab_gift_ticket_1: `EVENT`,
  contenthome_ticket_tab_gift_ticket_2: `{{value}} ตั๋วของขวัญ`,
  contenthome_ticket_tab_gift_ticket_button: `รับ`,
  contenthome_ticket_tab_gift_ticket_remaining: `ตั๋วที่มี`,
  contenthome_ticket_tab_ticket_purchase_button: `แลกตั๋ว`,
  contenthome_ticket_tab_ticket_history: `ประวัติการใช้ตั๋ว`,
  contenthome_ticket_tab_ticket_count: `{{count}} ตั๋ว`,
  contenthome_ticket_tab_ticket_count_plural: `{{count}} ตั๋ว`,
  contenthome_comment_tab_button: `ความคิดเห็น`,
  comment_order_recent_snackbar: `แสดงผลตามลำดับล่าสุด`,
  comment_order_likes_snackbar: `แสดงผลตามลำดับการถูกใจ`,
  comment_order_recent: `ตามวันที่ล่าสุด`,
  comment_order_likes: `ตามยอดไลก์`,
  contenthome_comment_empty: `ยังไม่มีความคิดเห็น`,
  contenthome_tickethistory: `ประวัติการใช้ตั๋ว`,
  contenthome_sidemenu_notice: `ประกาศ`,
  contenthome_sidemenu_clearhistory: `ลบประวัติการอ่านทั้งหมด`,
  contenthome_sidemenu_share: `แชร์`,
  share_popup_title: `แชร์`,
  share_link_copied_paste_toast: `คัดลอกที่อยู่แล้ว`,
  contenthome_sidemenu_download_autodelete: `ตั้งค่าลบอัตโนมัติตอนที่ดาวน์โหลดเมื่อหมดอายุ
ชั้นหนังสือ > ดาวน์โหลด`,
  contenthome_sidemenu_download_available: `ดาวน์โหลดได้`,
  contenthome_sidemenu_download_waiting: `รอดาวน์โหลด`,
  contenthome_sidemenu_download_complete: `ดาวน์โหลดสำเร็จ`,
  contenthome_sidemenu_download_purchase: `ดาวน์โหลดหลังจากซื้อ`,
  contenthome_sidemenu_download_fail: `ดาวน์โหลดไม่สำเร็จ`,
  contenthome_sidemenu_register_popup_title: `ต้องการลงทะเบียนอุปกรณ์ปัจจุบันหรือไม่?`,
  contenthome_sidemenu_register_popup_content: `การดาวน์โหลดนั้นสามารถทำได้บนอุปกรณ์ที่ลงทะเบียนเท่านั้น 
และปัจจุบันคุณไม่ได้ลงทะเบียนอุปกรณ์ใดๆ เลย 
คุณสามารถลงทะเบียนอุปกรณ์ได้ 2 เครื่องต่อบัญชี 
และเปลี่ยนอุปกรณ์ได้เดือนละ 1 ครั้ง`,
  settings_device_register_impossible_exceed_popup_title: `ไม่สามารถลงทะเบียนได้ เนื่องจากเกินจำนวนครั้งในการเปลี่ยนอุปกรณ์`,
  settings_device_register_impossible_exceed_popup_content: `สามารถเปลี่ยนการลงทะเบียนอุปกรณ์ได้ 1 ครั้งต่อเดือน`,
  settings_device_register_exceed_popup: `เกินจำนวนอุปกรณ์ที่ลงทะเบียนได้ กรุณายกเลิกอุปกรณ์หนึ่งเครื่องเพื่อลงทะเบียนเครื่องใหม่`,
  settings_device: `จัดการอุปกรณ์`,
  contenthome_sidemenu_download_data_popup_title: `ต้องการใช้เซลลูลาร์ดาต้าเพื่อดาวน์โหลดหรือไม่?`,
  contenthome_sidemenu_download_data_popup_content: `คุณไม่ได้ใช้ Wi-Fi อยู่ในตอนนี้ ซึ่งอาจมีค่าบริการเพิ่มเติมจากการใช้เซลลูลาร์ดาต้า
หากต้องการดาวน์โหลดด้วย Wi-Fi กรุณาเปิดที่ ตั้งค่า > ตั้งค่าข้อมูล`,
  contenthome_sidemenu_download_complete_popup_title: `{{title}} ดาวน์โหลดสำเร็จแล้ว`,
  contenthome_sidemenu_download_complete_popup_content: `ดาวน์โหลด {{episode}} ตอนแล้ว`,
  contenthome_sidemenu_download_complete_popup_content_plural: `ดาวน์โหลด {{count}} ตอนแล้ว`,
  contenthome_sidemenu_download_fail_popup_title: `{{title}} ดาวน์โหลดไม่สำเร็จ`,
  contenthome_sidemenu_download_fail_popup_content: `ดาวน์โหลด {{episode}} ตอนไม่สำเร็จ`,
  contenthome_sidemenu_download_fail_popup_content_plural: `ดาวน์โหลด {{count}} ตอนไม่สำเร็จ`,
  notification_notice_list_blank: `ไม่มีประกาศ`,
  contenthome_sidemenu_clearhistory_deleted: `ประวัติการอ่านถูกลบสำเร็จแล้ว`,
  contenthome_universe_matching_exploring: `กำลังค้นหา`,
  contenthome_universe_matching_type_ai: `จับคู่โดย AI`,
  contenthome_universe_title: `กับ {{title}}`,
  contenthome_universe_matching_type_ai_similar: `ผลงานที่คล้ายกับ
เรื่อง {{title}}`,
  contenthome_universe_matching_type_ai_drawing: `ผลงานที่มีลายเส้นคล้ายกับ
เรื่อง {{title}}`,
  contenthome_universe_matching_type_ai_genre: `ผลงานประเภท {{genre}}
เหมือนกับเรื่อง {{title}}`,
  contenthome_universe_matching_type_special: `จับคู่พิเศษ`,
  contenthome_universe_matching_type_special_other: `{{matching}} 
รวมถึง {{title}}`,
  contenthome_universe_matching_type_today: `จับคู่วันนี้`,
  contenthome_universe_matching_type_today_mostviewed: `ผลงานที่มีผู้อ่านมากที่สุดในวันนี้`,
  contenthome_universe_matching_type_today_mostpopular: `ผลงานที่ผู้ติดตามมากที่สุดในวันนี้`,
  contenthome_universe_matching_type_nextup: `{{type}} ที่จะอ่านภายหลัง`,
  contenthome_universe_matching_blank: `ไม่มียูนิเวิร์สที่จับคู่ได้`,
  contenthome_universe_matching_first: `ผลงานแรก`,
  contenthome_universe_matching_last: `ผลงานสุดท้าย`,
  contenthome_stop_sell_refund_popup: `ผลงานนี้ระงับการจำหน่ายแล้ว
ต้องการคืนตั๋วที่ไม่ได้ใช้งานหรือไม่?`,
  contenthome_stop_sell_toast: `ผลงานนี้ระงับการจำหน่ายแล้ว`,
  contenthome_prohibited_sell_popup: `ผลงานนี้ระงับการจำหน่ายแล้ว
จึงไม่สามารถเปิดอ่านได้`,
  contenthome_tickethistory_purchased: `ประวัติการได้รับ`,
  contenthome_tickethistory_used: `ประวัติการใช้`,
  contenthome_tickethistory_gidamu_minute: `1 ตั๋วฟรีทุกๆ {{count}} นาที`,
  contenthome_tickethistory_gidamu_minute_plural: `1 ตั๋วฟรีทุกๆ {{count}} นาที`,
  contenthome_tickethistory_gidamu_day: `1 ตั๋วฟรีทุกๆ {{count}} วัน`,
  contenthome_tickethistory_gidamu_day_plural: `1 ตั๋วฟรีทุกๆ {{count}} วัน`,
  contenthome_tickethistory_gidamu_hour: `1 ตั๋วฟรีทุกๆ {{count}} ชม.`,
  contenthome_tickethistory_gidamu_hour_plural: `1 ตั๋วฟรีทุกๆ {{count}} ชม.`,
  contenthome_tickethistory_popup_detail_minute_1: `หลังจากใช้ตั๋ว'รออ่านฟรี' เมื่อรออีก {{count}} นาที จะได้รับใหม่อีก 1 ตั๋ว`,
  contenthome_tickethistory_popup_detail_minute_1_plural: `หลังจากใช้ตั๋ว'รออ่านฟรี' เมื่อรออีก {{count}} นาที จะได้รับใหม่อีก 1 ตั๋ว`,
  contenthome_tickethistory_popup_detail_hour_1: `หลังจากใช้ตั๋ว'รออ่านฟรี' เมื่อรออีก {{count}} ชม. จะได้รับใหม่อีก 1 ตั๋ว`,
  contenthome_tickethistory_popup_detail_hour_1_plural: `หลังจากใช้ตั๋ว'รออ่านฟรี' เมื่อรออีก {{count}} ชม. จะได้รับใหม่อีก 1 ตั๋ว`,
  contenthome_tickethistory_popup_detail_day_1: `หลังจากใช้ตั๋ว'รออ่านฟรี' เมื่อรออีก {{count}} วัน จะได้รับใหม่อีก 1 ตั๋ว`,
  contenthome_tickethistory_popup_detail_day_1_plural: `หลังจากใช้ตั๋ว'รออ่านฟรี' เมื่อรออีก {{count}} วัน จะได้รับใหม่อีก 1 ตั๋ว`,
  contenthome_tickethistory_popup_detail_2: `{{value}} ตอนล่าสุด (ไม่รวมตอนฟรี) ใช้กับตั๋วรออ่านฟรีไม่ได้`,
  contenthome_tickethistory_popup_detail_3: `สามารถอ่านเว็บตูนหนึ่งตอนได้เป็นเวลา 3 วัน ด้วยตั๋วดังกล่าว`,
  contenthome_tickethistory_gift_event: `ของขวัญกิจกรรม`,
  ticket_history_used_newbie: `สิทธิประโยชน์ผู้ใช้ใหม่`,
  contenthome_tickethistory_cancelled: `ยกเลิกสำเร็จ`,
  contenthome_tickethistory_refund_title: `ยกเลิกการแลกตั๋ว`,
  contenthome_tickethistory_refund_purchase_info: `ข้อมูลการแลก`,
  contenthome_tickethistory_refund_purchase_info_date: `วันที่แลก`,
  contenthome_tickethistory_refund_purchase_info_number: `หมายเลขการแลก`,
  contenthome_tickethistory_refund_purchase_info_ticket: `จำนวนตั๋วที่แลก`,
  contenthome_tickethistory_refund_purchase_info_ticket_plural: `จำนวนตั๋วที่แลก`,
  contenthome_tickethistory_refund_purchase_info_ticket_bonus: `{{count}} ตั๋ว +{{bonus}} ตั๋วโบนัส`,
  contenthome_tickethistory_refund_purchase_info_ticket_bonus_plural: `{{count}} ตั๋ว +{{bonus}} ตั๋วโบนัส`,
  contenthome_tickethistory_refund_info: `ข้อมูลการคืน`,
  contenthome_tickethistory_refund_info_ticket: `จำนวนตั๋วที่ยกเลิกได้`,
  contenthome_tickethistory_refund_info_ticket_cash: `แคชต่อ 1 ตั๋ว`,
  contenthome_tickethistory_refund_info_cash: `แคชที่คืน`,
  contenthome_tickethistory_refund_info_cash_expired: `แคชของขวัญที่หมดอายุ`,
  contenthome_tickethistory_refund_info_cash_able: `แคชที่คืนได้`,
  contenthome_tickethistory_refund_notice_price: `แจ้งเกี่ยวกับมูลค่าการคืน`,
  contenthome_tickethistory_refund_notice_price_1: `ยอดที่สามารถคืนได้ ซึ่งไม่รวมแคชของขวัญที่หมดอายุ`,
  contenthome_tickethistory_refund_notice_price_2: `ข้อมูลของยอดยกเลิกจริง และประวัติของแคชและตั๋ว 
อาจแตกต่างกัน เนื่องจากข้อมูลแคชของขวัญที่หมดอายุ`,
  contenthome_tickethistory_refund_notice_policy: `แจ้งเกี่ยวกับนโยบายการคืน`,
  contenthome_tickethistory_refund_notice_policy_1: `ตั๋วที่แลกด้วยแคชของขวัญสามารถคืนได้
ก่อนเวลาหมดอายุของแคชของขวัญ`,
  contenthome_tickethistory_refund_notice_policy_2: `ตั๋วที่ได้รับแจกฟรีไม่สามารถคืนได้ 
เช่น 'ตั๋วของขวัญวันนี้', 'ตั๋วสิทธิพิเศษของผู้ใช้ใหม่', 
'ตั๋วโบนัสจากแพ็กเกจ' เป็นต้น`,
  contenthome_tickethistory_refund_notice_policy_3: `สามารถคืนตั๋วเป็นแคชของ KAKAO WEBTOON ได้เท่านั้น`,
  contenthome_tickethistory_refund_notice_policy_4: `ไม่สามารถย้อนกลับการยกเลิกการแลกตั๋วได้ กรุณาดำเนินการด้วยความรอบคอบ`,
  contenthome_tickethistory_refund_notice_policy_5: `กรุณาติดต่อทีมงานเกี่ยวกับการคืนแคช`,
  contenthome_tickethistory_refund_button: `ยกเลิกตั๋ว`,
  contenthome_tickethistory_refund_popup: `ต้องการยกเลิกตั๋วหรือไม่?`,
  contenthome_tickethistory_refund_detail_popup: `ตั๋วที่ยกเลิก: {{ticket}} ตั๋ว / แคชที่คืน: {{cash}}`,
  contenthome_tickethistory_refund_detail_popup_plural: `ตั๋วที่ยกเลิก: {{ticket}} ตั๋ว / แคชที่คืน: {{cash}}`,
  contenthome_tickethistory_refund_snackbar: `การแลกตั๋วถูกยกเลิกแล้ว`,
  contenthome_tickethistory_used_gift_event: `ตั๋วของขวัญ (กิจกรรม)`,
  contenthome_tickethistory_used_gift_newbie: `ตั๋วของขวัญ (ผู้ใช้ใหม่)`,
  gift_ticket_fail_received_popup: `คุณได้รับของขวัญนี้แล้ว`,
  gift_ticket_fail_expired_popup: `หมดอายุแล้ว`,
  viewer_capture_aos_snackbar: `ไม่สามารถจับภาพหน้าจอได้
ตามนโยบายลิขสิทธิ์`,
  viewer_capture_ios_popup_title: `รายละเอียดทางลิขสิทธิ์`,
  viewer_capture_ios_popup_content: `การเผยแพร่และแชร์ภาพผลงานโดยไม่ได้รับอนุญาต
จะถูกดำเนินคดีตามกฎหมาย ทีมงานสามารถตรวจสอบ
ประวัติการบันทึกภาพหน้าจอได้ทั้งหมดผ่านระบบติดตาม
และเมื่อพบว่ามีการเผยแพร่ คุณจะได้รับโทษตามกฎหมาย`,
  viewer_record_snackbar: `ไม่สามารถบันทึกหน้าจอได้
ตามนโยบายลิขสิทธิ์`,
  viewer_stop_sale_popup: `ไม่สามารถอ่านได้ เนื่องจากระงับการจำหน่าย`,
  viewer_related_novel: `นิยายที่เกี่ยวกับเรื่องนี้`,
  contenthome_alive_download_popup_content: `สามารถอ่านได้หลังดาวน์โหลด
แนะนำให้เชื่อมต่อกับ Wi-Fi`,
  viewer_marathon_viewing_snackbar: `เปลี่ยนเป็นโหมดอ่านต่อเนื่อง ตั๋วที่มีอยู่จะถูกใช้โดยอัตโนมัติเมื่อจำเป็นต้องใช้ตั๋ว`,
  viewer_marathon_viewing_last_ep_toast: `ไม่มีตอนต่อไป`,
  viewer_marathon_viewing_first_ep_toast: `ไม่มีตอนก่อนหน้านี้`,
  viewer_marathon_viewing_guide_app: `เปิดโหมดอ่านต่อเนื่อง สามารถเพลิดเพลินกับฉากสุดท้ายไปยังตอนถัดไปได้อย่างราบรื่น`,
  viewer_end_gidamu_plus_info: `อ่านฟรีได้ทุกๆ {{value}} ชม. เรื่อง ‘{{contentname}}’ `,
  viewer_end_like_first: `ลองกดถูกใจเป็นครั้งแรกสิ`,
  viewer_end_like_snackbar: `ชอบเรื่องนี้มากล่ะสิ!
คุณสามารถกดถูกใจได้สูงสุดตอนละ 5 ครั้งนะ`,
  viewer_end_comment_count: `ดู {{value}} ความคิดเห็น`,
  viewer_end_comment_count_zero: `0 ความคิดเห็น`,
  viewer_end_comment_count_v4: `{{value}} ความคิดเห็น`,
  viewer_end_comment_button: `ดูความคิดเห็น`,
  viewer_end_next_button: `อ่านต่อตอนที่ <white>{{value}}</white>`,
  viewer_end_next_button_v4: `อ่านต่อตอนที่ {{value}}`,
  viewer_end_last_episode: `ยังไม่มีตอนต่อไป`,
  viewer_end_next_pull: `ปัดลงเพื่อดู <grey>{{value}}</grey>`,
  viewer_end_recommendation_v4: `ผลงานที่คล้ายกัน`,
  viewer_ep_list_free: `ฟรี`,
  viewer_ep_list_gidamu: `รออ่านฟรี`,
  viewer_ep_list_rent: `เช่า`,
  viewer_ep_list_possess: `ซื้อเก็บ`,
  viewer_top_button: `กลับสู่ด้านบน`,
  viewer_page_swipe_snackbar: `ปัดไปทางซ้าย`,
  viewer_page_swipe_right_snackbar: `ปัดไปทางขวา`,
  viewer_setting_zoom_button: `ขยาย/ย่อ`,
  viewer_setting_preview_comment_button: `ดูความคิดเห็น`,
  viewer_setting_remember_button: `จำตำแหน่งที่เคยอ่าน`,
  viewer_setting_autoscroll_button: `เลื่อนอัตโนมัติ`,
  viewer_setting_autoscroll_button_v4: `ความเร็วเลื่อนอัตโนมัติ`,
  viewer_setting_autoscroll_toast: `เปลี่ยนเป็นโหมดเลื่อนอัตโนมัติ\n ความเร็วในการเลื่อนสามารถเปลี่ยนแปลงได้ในตั้งค่า`,
  viewer_setting_bgm_button: `BGM`,
  viewer_setting_brightness: `ความสว่างหน้าจอ`,
  viewer_setting_share_ep_button: `แชร์`,
  viewer_setting_capture_screen_button: `จับภาพหน้าจอ`,
  viewer_setting_view_page_button: `อ่านแบบปัด`,
  viewer_setting_view_scroll_button: `อ่านแบบเลื่อน`,
  viewer_setting_capture_button: `จับภาพหน้าจอ`,
  viewer_setting_capture_saved: `บันทึกลงในอัลบั้มรูปของฉันแล้ว`,
  viewer_setting_capture_access_required_popup: `จำเป็นต้องอนุญาตสิทธิ์เพื่อการบันทึกภาพหน้าจอ`,
  viewer_setting_capture_access_authorization_required: `ต้องได้รับสิทธิ์การเข้าถึงรูปภาพ จาก KAKAO WEBTOON เพื่อบันทึกหน้าจอที่ถ่ายไว้`,
  viewer_setting_hide_comment_off: `ซ่อนความคิดเห็น`,
  viewer_setting_hide_comment_on: `เปิดความคิดเห็น`,
  viewer_setting_enlarge_off: `การขยาย ปิด`,
  viewer_setting_enlarge_on: `การขยาย เปิด`,
  viewer_setting_last_viewed_off: `จำตำแหน่งที่เคยอ่าน - ปิด`,
  viewer_setting_last_viewed_on: `จำตำแหน่งที่เคยอ่าน - เปิด`,
  viewer_setting_sound_off: `ปิดเสียง`,
  viewer_setting_sound_on: `เปิดเสียง`,
  viewer_setting_view_page: `อ่านแบบปัด`,
  viewer_setting_view_scroll: `อ่านแบบเลื่อน`,
  viewer_setting_view_page_switch_toast: `เปลี่ยนเป็นอ่านแบบปัด`,
  viewer_setting_view_scroll_switch_toast: `เปลี่ยนเป็นอ่านแบบเลื่อน`,
  viewer_setting_enlarge_on_text: `แตะหน้าจอสองครั้งเพื่อเปิดขยาย/ย่อ`,
  viewer_setting_enlarge_off_text: `แตะหน้าจอสองครั้งเพื่อปิดขยาย/ย่อ`,
  viewer_setting_preview_comment_on_text: `เปิดดูความคิดเห็น BEST `,
  viewer_setting_preview_comment_off_text: `ปิดดูความคิดเห็น BEST `,
  viewer_setting_last_viewed_on_text: `เปิดจำตำแหน่งที่เคยอ่าน`,
  viewer_setting_last_viewed_off_text: `ปิดจำตำแหน่งที่เคยอ่าน`,
  viewer_setting_autoscroll_on_text: `กดค้างที่หน้าจอ เพื่อเปิดเลื่อนอัตโนมัติ`,
  viewer_setting_autoscroll_off_text: `กดค้างที่หน้าจอ เพื่อปิดเลื่อนอัตโนมัติ`,
  viewer_setting_sound_on_text: `เปิดBGM เมื่ออ่านอีพี`,
  viewer_setting_sound_off_text: `ปิดBGM เมื่ออ่านอีพี`,
  viewer_onetouch_popup_title: `ต้องใช้ {{value}} ตั๋ว สำหรับอ่านตอนถัดไป`,
  viewer_onetouch_popup_title_1_web: `ต้องใช้ตั๋วสำหรับ {{value}}`,
  viewer_onetouch_popup_title_2_web: `เพื่ออ่านตอนต่อไป`,
  viewer_onetouch_popup_title_ticket: `คุณต้องการเช่าตอนเพื่ออ่านตอนต่อไปหรือไม่`,
  viewer_onetouch_popup_title_cash: `คุณต้องการเช่าตอนอ่าน หลังจากเติมแคชสำเร็จหรือไม่`,
  viewer_onetouch_popup_subtitle_gidamu: `ไม่สามารถใช้ตั๋วรออ่านฟรีกับตอนนี้ได้`,
  viewer_onetouch_popup_content_balance: `แคชในบัญชี`,
  viewer_onetouch_popup_content_ticket: `ตั๋วเช่า (365 วัน)`,
  viewer_onetouch_popup_button_ticket: `กดเช่า`,
  viewer_onetouch_popup_button_cash: `เติมแคชเพื่อเช่า`,
  viewer_onetouch_popup_button_options: `ดูแพ็กเกจเช่าและซื้อเก็บ`,
  comment_title: `<bold>ความคิดเห็น</bold> {{count}}`,
  comment_title_plural: `<bold>ความคิดเห็น</bold> {{count}}`,
  comment_empty_first: `เพิ่มความคิดเห็นแรกดูสิ`,
  comment_account_deleted: `สมาชิกที่ลบบัญชีไปแล้ว`,
  comment_unknown_user: `Unknown`,
  comment_see_comment_spoiler: `ดูความคิดเห็นที่มีเนื้อหาสปอย`,
  comment_button_dislike: `ไม่ถูกใจ`,
  comment_button_dislike_plural: `ไม่ถูกใจ`,
  comment_reply_title: `<bold>ตอบกลับ</bold> {{count}}`,
  comment_reply_title_plural: `<bold>ตอบกลับ</bold> {{count}}`,
  comment_write_reply_title: `เขียนความคิดเห็น`,
  comment_reply: `ตอบกลับ`,
  comment_reply_plural: `ตอบกลับ`,
  comment_button_delete: `ลบ`,
  comment_button_delete_popup: `ต้องการลบความคิดเห็นที่เลือกหรือไม่?`,
  comment_deleted_toast: `ความคิดเห็นที่ลบไปแล้ว `,
  comment_deleted_click_action_toast: `ความคิดเห็นถูกลบแล้ว 
จึงไม่สามารถจัดการคำขอได้
`,
  comment_button_report: `รายงาน`,
  comment_report_already_report: `ระบบได้รับการรายงานแล้ว`,
  comment_before_enter: `กรุณาเขียนความคิดเห็น`,
  comment_reply_before_enter: `กรุณาใส่ข้อความตอบกลับ`,
  comment_reply_more: `ดูเพิ่มเติม`,
  comment_button_enter: `โพสต์`,
  comment_button_block: `บล็อก`,
  comment_block_popup_title: `คุณต้องการจะบล็อกคุณ {{nickname}} ไหม`,
  comment_block_popup_content: `คุณไม่สามารถอ่านความคิดเห็นของผู้ใช้ที่ถูกบล็อกได้`,
  comment_block_toast: `ผู้ใช้ถูกบล็อก`,
  comment_already_blocked_toast: `ผู้ใช้บัญชีนี้ถูกบล็อกแล้ว`,
  comment_already_unblocked_toast: `ผู้ใช้บัญชีนี้ถูกปลดบล็อกแล้ว`,
  comment_block_displayed: `ความคิดเห็นจากผู้ใช้ที่ถูกบล็อก`,
  comment_button_unblock: `ปลดบล็อค`,
  comment_unblock_popup_title: `ต้องการจะเลิกบล็อก คุณ {{nickname}} ไหม`,
  comment_unblock_popup_content: `เมื่อคุณปลดบล็อก คุณถึงจะอ่านความคิดเห็นของผู้ใช้ได้`,
  comment_unblock_toast: `ผู้ใช้ถูกปลดบล็อกแล้ว`,
  comment_write_title: `เขียนความคิดเห็น`,
  comment_write_spoiler_button: `สปอย`,
  comment_write_snackbar: `ไม่สามารถเขียนความคิดเห็นเพิ่มได้ทันที
หลังจากโพสต์ความคิดเห็นไป`,
  login_comment_write_popup: `กรุณาเข้าสู่ระบบ
เพื่อเขียนความคิดเห็น`,
  login_comment_exceed_toast: `ตัวอักษรเกินจำนวนจำกัดที่สามารถเขียนได้
`,
  comment_report_spam: `สแปม/โฆษณา`,
  comment_report_violence: `ด่าทอ/การโจมตีตัวบุคคล`,
  comment_report_illegal: `ข้อมูลผิดกฎหมาย`,
  comment_report_privacy: `เผยแพร่ข้อมูลส่วนบุคคล`,
  comment_report_sexual: `ลามก/ล่อแหลม`,
  comment_report_repeatedly: `ฟลัดข้อความ`,
  comment_report_other: `อื่นๆ`,
  comment_report_other_inputbox: `เลือกหัวข้ออื่นๆ แล้วใส่คำอธิบาย (สูงสุด 500 ตัวอักษร)`,
  comment_report_submitted_toast_short: `ได้รับการรายงานแล้ว`,
  comment_report_submitted_toast: `ได้รับการรายงานแล้ว
ความคิดเห็นดังกล่าวจะถูกจัดการตามนโยบายการปฏิบัติการ`,
  comment_report_read_more_button: `ดูเพิ่มเติม`,
  comment_report_info: `กรุณารายงานความคิดเห็นที่ไม่เหมาะสมกับ
วัตถุประสงค์การใช้บริการหรือมีเนื้อหาที่ผิดกฎหมาย 
ความคิดเห็นที่รายงานเข้ามาจะถูกดำเนินการ
ตามนโยบายการปฏิบัติการ 
และหากรายงานเท็จ คุณอาจถูกระงับการใช้งานได้`,
  comment_report: `รายงาน`,
  comment_report_button: `รายงาน`,
  login_comment_report_popup: `กรุณาเข้าสู่ระบบ
เพื่อรายงานความคิดเห็น`,
  comment_regulated: `ความคิดเห็นนี้ถูกจำกัดไว้`,
  comment_regulated_content: `ความคิดเห็นถูกซ่อนไว้ชั่วคราว 
เนื่องจากได้รับการแจ้งการละเมิดสิทธิ`,
  comment_regulated_popup_title: `คุณถูกระงับการเขียนความคิดเห็นตามนโยบายการปฏิบัติการ`,
  comment_regulated_popup_date_range: `ระยะเวลา: {{start}}~{{end}}`,
  comment_regulated_popup_date_permanent: `ระยะเวลา: ระงับถาวร`,
  comment_regulated_popup_detail_1: `ในช่วงระยะเวลาที่ถูกระงับ ยังสามารถใช้บริการทั้งหมดได้ ยกเว้นการเขียนคอมเมนต์`,
  comment_regulated_popup_detail_2: `การระงับจะถูกปลดให้โดยอัตโนมัติเมื่อสิ้นสุดระยะดังกล่าว`,
  comment_regulated_popup_detail_3: `หากทำพฤติกรรมผิดกฎซ้ำอีก อาจถูกลงโทษหนักขึ้น `,
  comment_regulated_popup_detail_4: `กรุณาติดต่อทีมงานเพื่อสอบถามเพิ่มเติม`,
  more_title_ticket_history: `ประวัติการแลกตั๋ว`,
  ticket_history_add_tab: `ประวัติตั๋วที่ได้รับ`,
  cash_history_used_detail: `ข้อมูลของยอดยกเลิกจริง และประวัติของแคชและตั๋ว 
อาจแตกต่างกัน เนื่องจากข้อมูลแคชของขวัญที่หมดอายุ`,
  cash_history_used_rental: `แลก {{count}} ตั๋วเช่า`,
  cash_history_used_rental_plural: `แลก {{count}} ตั๋วเช่า`,
  cash_history_used_possession: `แลก {{count}} ตั๋วซื้อเก็บ`,
  cash_history_used_possession_plural: `แลก {{count}} ตั๋วซื้อเก็บ`,
  ticket_history_add_gift: `{{count}} ตั๋วของขวัญ`,
  ticket_history_add_gift_plural: `{{count}} ตั๋วของขวัญ`,
  ticket_history_add_gidamu: `1 ตั๋วรออ่านฟรี`,
  cash_history_valid_date: `หมดอายุ {{date}}`,
  cash_history_used_rental_refunded: `ยกเลิกการแลก {{count}} ตั๋วเช่า`,
  cash_history_used_rental_refunded_plural: `ยกเลิกการแลก {{count}} ตั๋วเช่า`,
  cash_history_used_possession_refunded: `ยกเลิกการแลก {{count}} ตั๋วซื้อเก็บ`,
  cash_history_used_possession_refunded_plural: `ยกเลิกการแลก {{count}} ตั๋วซื้อเก็บ`,
  ticket_history_add_empty: `ไม่มีประวัติได้รับตั๋ว`,
  ticket_history_used_tab: `ประวัติการอ่าน`,
  ticket_history_episode_range: `ตอนที่ {{start}} - ตอนที่ {{end}}`,
  ticket_history_used_empty: `ไม่มีประวัติการใช้ตั๋ว`,
  ticket_purchase_title: `แลกตั๋ว`,
  ticket_purchase_title_detail: `ใช้ตั๋วกับเรื่องที่คุณแลกตั๋วไว้เท่านั้น`,
  ticket_purchase_balance_rental: `ตั๋วเช่าที่มี (รวมตั๋วรออ่านฟรีและตั๋วของขวัญ)`,
  ticket_purchase_balance_possession: `ตั๋วซื้อเก็บที่มี`,
  ticket_purchase_ep_unread: `ตอนที่ยังไม่ได้อ่าน (ไม่รวมตอนฟรี)`,
  ticket_purchase_balance_cash: `แคชที่มี`,
  ticket_purchase_ineligible: `ผลงานที่ไม่ต้องแลกตั๋ว`,
  ticket_purchase_rental: `แลก<purple>ตั๋วเช่า</purple>`,
  ticket_purchase_possession: `แลก<blue>ตั๋วซื้อเก็บ</blue>`,
  ticket_purchase_all: `แลกในครั้งเดียว`,
  ticket_purchase_bonus_1: `{{count}} ตั๋ว`,
  ticket_purchase_bonus_1_plural: `{{count}} ตั๋ว`,
  ticket_purchase_bonus_2: ` + {{count}} ตั๋วโบนัส`,
  ticket_purchase_bonus_2_plural: ` + {{count}} ตั๋วโบนัส`,
  ticket_purchase_bonus_rental_2: `{{count}} ตั๋ว <purple>+ {{bonus}} ตั๋วโบนัส</purple>`,
  ticket_purchase_bonus_rental_2_plural: `{{count}} ตั๋ว <purple>+ {{bonus}} ตั๋วโบนัส</purple>`,
  ticket_purchase_bonus_possession_2: `{{count}} ตั๋ว <blue>+ {{bonus}} ตั๋วโบนัส</blue>`,
  ticket_purchase_bonus_possession_2_plural: `{{count}} ตั๋ว <blue>+ {{bonus}} ตั๋วโบนัส</blue>`,
  ticket_purchase_rental_regulation_1: `เวลาที่อ่านได้ : สามารถอ่านได้ ภายใน 365 วันหลังใช้ตั๋วเช่าเปิดอ่าน`,
  ticket_purchase_rental_regulation_2: `สามารถอ่านได้ภายใน 365 วัน หลังจากใช้ตั๋วเช่าเปิดอ่าน ไม่ใช่การแลกตั๋วอย่างเดียว`,
  ticket_purchase_cashfriend: `แคชที่รับได้ตอนนี้`,
  ticket_purchase_rental_discount: `ลดราคาตั๋วเช่า`,
  ticket_purchase_possession_discount: `ลดราคาตั๋วซื้อเก็บ`,
  ticket_purchase_total_count: `ทั้งหมด`,
  ticket_purchase_total_price: `มูลค่า`,
  ticket_purchase_total_regulation_1: `ตั๋วที่สามารถใช้กับผลงานนี้เท่านั้น`,
  ticket_purchase_total_regulation_2: `ตั๋วโบนัสไม่สามารถยกเลิกการแลกได้`,
  ticket_purchase_cancel: `ยกเลิกการแลกตั๋ว`,
  ticket_purchase_total_limit_toast: `จำกัดการแลกในครั้งเดียว
สูงสุดที่ 500,000 แคช`,
  ticket_purchase_shortage: `แคชไม่เพียงพอ`,
  ticket_purchase_shortage_amount: `ขาดอีก`,
  more_title_cash_add: `เติมแคช`,
  ticket_purchase_shortage_add_notice: `กรณีมีการชำระเงินเกิน {{value}} แคชขึ้นไป 
จะมีการแจ้งเตือน ‘ยืนยันการซื้อในแอป’ 
ปรากฏหลายครั้ง ตามนโยบายการซื้อในแอป`,
  ticket_purchase_successful_rental: `แลก {{value}} ตั๋วเช่าสำเร็จ`,
  ticket_purchase_successful_possession: `แลก {{value}} ตั๋วซื้อเก็บสำเร็จ`,
  ticket_purchase_successful_balance_cash: `แคชคงเหลือ: {{value}} แคช`,
  ticket_purchase_regulation: `แจ้งข้อกำหนด`,
  ticket_purchase_regulation_1: `คอนเทนต์นี้เป็นสินค้าที่ไม่สามารถยกเลิกหรือขอคืนเงินได้
เนื่องจากมีการชำระเงิน (ใช้งาน) สำเร็จแล้ว `,
  ticket_purchase_regulation_2: `การอัปเดตอาจมีความล่าช้าตามสถานการณ์ของผู้เผยแพร่ 
และไม่สามารถยกเลิกการแลกได้ด้วยเหตุผลของความล่าช้า`,
  ticket_purchase_regulation_3: `ราคาขายอาจมีการเปลี่ยนแปลงตามสถานการณ์ของผู้ให้บริการได้ 
แต่คุณไม่สามารถยกเลิกการแลกด้วยเหตุผลของการเปลี่ยนแปลง
ราคาคอนเทนต์ได้`,
  ticket_purchase_regulation_4: `สินค้าประเภทแพ็กเกจสามารถยกเลิกได้เฉพาะตั๋วแบบมีค่าบริการเท่านั้นโดยไม่รวมส่วนที่ได้รับแจกเป็นโบนัส`,
  ticket_purchase_regulation_5: `ตั๋วของขวัญถูกนับรวมอยู่ในตั๋วเช่าที่มีด้วย`,
  ticket_purchase_regulation_6: `แคชของขวัญถูกรวมอยู่ในแคชที่มีด้วย`,
  ticket_purchase_regulation_7: `หากได้รับตั๋วของขวัญ หลังจากใช้วิธี ‘แลกในครั้งเดียว’ ไปแล้ว 
อาจจะทำให้คุณมีตั๋วที่เหลือ`,
  ticket_purchase_regulation_8: `การแลกด้วยวิธี ‘แลกในครั้งเดียว’ จะนำเสนอตัวเลือกให้เหมาะตามจำนวนตอนที่ยังไม่ได้อ่าน`,
  ticket_purchase_regulation_9: `เมื่อแลกตั๋วด้วยวิธี ‘แลกในครั้งเดียว’ ตั๋วโบนัสจะถูกแจก
พร้อมกับการแลกแยกตามรายการ`,
  ticket_purchase_regulation_10: `หากคุณต้องการรับแคชคืนหลังจากแลกตั๋ว ตั๋วที่ยังไม่ได้ใช้อาจถูกยกเลิกเพื่อรับแคชคืน`,
  more_title_cash_history: `ประวัติแคช`,
  cash_history_add_tab: `ประวัติแคชที่ได้รับ`,
  cash_history_pass: `CASH PASS VIP`,
  cash_history_pass_banner: `มีโอกาสรับแคชแบ็กสูงสุด {{value}}%  เมื่อเข้าร่วม`,
  cash_history_pass_benefit: `ได้สิทธิประโยชน์แคชแบ็ก {{value}}%`,
  cash_history_pass_detail_button: `ดูรายละเอียด`,
  cash_history_reciept_info: ` `,
  cash_history_add_purchased: `เติม <gold>{{value}} แคช</gold>`,
  cash_history_expiration_date: `{{value}} แคช จะหมดอายุใน {{date}}`,
  cash_history_expiration_date_2lines: `{{value}} แคช 
จะหมดอายุใน {{date}}`,
  cash_history_event: `กิจกรรม ・ {{campaign}}`,
  cash_history_currency: `฿{{value}}`,
  cash_history_administrator: `เรียกคืนโดยผู้ดูแล`,
  cash_history_administrator_added: `แจกโดยผู้ดูแล`,
  cash_history_store_refunded: `ขอคืนแคชจากรีฟันด์แล้ว`,
  cash_history_add_coupon: `แลกคูปอง`,
  cash_history_add_coupon_detail: `แลกคูปอง ・ {{campaign}}`,
  cash_history_add_auto_bonus: `เติมอัตโนมัติ ・ แจกโบนัส {{value}} แคช`,
  cash_history_add_purchased_bonus: `เติมแคช ・ แจกโบนัส {{value}} แคช`,
  cash_history_minus_refunded: `ยกเลิกการเติม {{value}} แคช`,
  cash_history_minus_purchased: `เติม {{value}} แคช`,
  cash_history_added_empty: `ไม่มีประวัติการเติมแคช`,
  cash_history_used_tab: `ประวัติการใช้`,
  cash_history_used_empty: `ไม่มีประวัติการใช้แคช`,
  more_title_cash_add_auto: `เติมแคชอัตโนมัติ`,
  cash_add_pass_benefit: `<bold>CASH PASS VIP</bold> 
แคชแบ็กสูงสุด {{value}}%`,
  cash_add_auto_unapplied: `มีโอกาสรับแคชแบ็กสูงสุด {{value}}%  เมื่อเข้าร่วม`,
  cash_add_balance: `แคชที่มี`,
  cash_add_pass: `CASH PASS VIP`,
  cash_add_pass_inuse: `กำลังใช้งาน`,
  cash_add_title: `เติม<gold>แคช</gold>`,
  cash_add_first_purchase_event: `เติมครั้งแรก ลดทันที 55%`,
  cash_add_discount_title: `ลดราคาแคช`,
  cash_add_authentication_popup: `ต้องยืนยันตัวให้เรียบร้อยจึงจะสามารถใช้บริการต่อได้ 
เนื่องจากเกินยอดที่จำกัดของเดือนนี้แล้ว ผู้ไม่ได้ยืนยันตัวตน : สูงสุด $50 ต่อเดือน`,
  cash_add_authentication_button: `ตรวจสอบ`,
  cash_add_payment_limit_popup_title: `เกินวงเงินที่สามารถชำระได้`,
  cash_add_payment_limit_popup_content: `คุณถูกจำกัดการใช้บริการชำระเงิน
เนื่องจากเกินวงเงินของเดือนนี้แล้ว วงเงินจะถูกรีเซตทุกวันที่ 1 ของเดือน 
เวลาประมาณ 00:00`,
  cash_add_payment_limit_exceed_popup: `เกินยอดจำกัดของคงเหลือ`,
  cash_add_payment_limit_exceed_popup_content: `ยอดจำกัดของยอดคงเหลือคือ {{value1}} แคช 
คุณสามารถเติมได้อีก {{value2}} แคช`,
  cash_add_payback: `{{value}} แคช <gold>+ {{bonus}} แคช</gold>`,
  cash_add_item_badge_recommend: `แนะนำ`,
  cash_add_item_badge_popular: `ยอดนิยม`,
  cash_add_agree_button: `ยินยอมตามรายละเอียดการใช้งานด้านล่าง
และดำเนินการชำระเงิน`,
  cash_add_next_button: `ถัดไป`,
  cash_add_guides: `แจ้งเกี่ยวกับการซื้อ`,
  cash_add_amount_popup_title: `เลือกจำนวนแคช`,
  cash_add_payment_popup_title: `เลือกช่องทางการชำระเงิน`,
  cash_add_payment_popup_button: `ชำระ`,
  cash_add_payment_processed_toast: `กำลังดำเนินการ
กรุณารอสักครู่`,
  cash_add_payment_processed_popup: `การชำระเงินของคุณอยู่ในระหว่างดำเนินการ อาจใช้เวลาประมาณ 20 วินาทีและข้อความนี้จะปิดโดยอัตโนมัติเมื่อชำระเงินเรียบร้อยแล้ว`,
  cash_add_success_popup: `เติม {{value}} แคช สำเร็จ`,
  cash_add_balance_popup: `แคชที่มี: {{value}} แคช`,
  cash_add_fail_popup: `เติม {{value}} แคช ไม่สำเร็จ
กรุณาลองใหม่อีกครั้ง`,
  cash_add_fail_popup_content: `ข้อมูลการชำระเงินไม่ถูกต้อง`,
  cash_add_pending_toast: `การชำระเงินไม่สำเร็จ โปรดตรวจสอบว่าช่องทางการชำระเงินที่เชื่อมต่อกับ Google Store มีปัญหาหรือไม่ หากไม่พบปัญหา ขอให้กลับไปหน้าเติมแคชอีกครั้ง`,
  cash_add_payment_processing_popup: `กำลังดำเนินการชำระเงิน โปรดตรวจสอบอีกครั้งในภายหลังว่าได้รับแคชสำเร็จหรือไม่`,
  error_unsupported_browser: `ไม่รองรับเบราว์เซอร์เวอร์ชันนี้
กรุณาอัปเดตเป็นเวอร์ชันล่าสุดเพื่อใช้งาน`,
  error_unsupported_os: `ไม่รองรับ OS เวอร์ชันนี้
กรุณาอัปเดตเป็นเวอร์ชันล่าสุดเพื่อใช้งาน`,
  billing_msg_invalid_msg: `คำขอไม่ถูกต้อง`,
  billing_msg_invalid_parameter: `ข้อมูลที่ร้องขอไม่ถูกต้อง`,
  billing_msg_service_fail: `เกิดปัญหาที่ไม่ทราบสาเหตุ`,
  billing_msg_invalid_required_parameter: `ไม่มีพารามิเตอร์ที่ต้องการ`,
  billing_msg_fail_get_user_info: `ค้นหาข้อมูลผู้ใช้ไม่สำเร็จ`,
  billing_msg_invalid_user_info: `ข้อมูลผู้ใช้ไม่ถูกต้อง`,
  billing_msg_invalid_user_region: `ประเทศที่ใช้บริการไม่ถูกต้อง`,
  billing_msg_invalid_billing_hash: `ขอการยืนยันข้อมูลล้มเหลว`,
  billing_msg_intro_fail_get_account_balance: `ค้นหายอดแคชคงเหลือไม่สำเร็จ`,
  billing_msg_intro_fail_get_view_intro: `ค้นหาข้อมูลผลิตภัณฑ์ไม่สำเร็จ`,
  billing_msg_intro_payment_policy_not_exist: `ไม่มีข้อมูลเงื่อนไขการชำระเงิน`,
  billing_msg_intro_payment_item_not_exist: `ไม่มีข้อมูลรายการชำระเงิน`,
  billing_msg_request_invalid_price: `ข้อมูลจำนวนการชำระเงินไม่ถูกต้อง`,
  billing_msg_request_invalid_item_id: `ข้อมูลผลิตภัณฑ์การชำระเงินไม่ถูกต้อง`,
  billing_msg_request_fail_get_item_info: `ค้นหาข้อมูลผลิตภัณฑ์ไม่สำเร็จ`,
  billing_msg_request_item_not_exists: `ไม่มีข้อมูลผลิตภัณฑ์`,
  billing_msg_request_fail_get_payment_id: `ลงทะเบียนข้อมูลการชำระเงินไม่สำเร็จ`,
  billing_msg_request_fail_get_pg_url: `ตั้งค่าข้อมูลการชำระเงินไม่สำเร็จ`,
  billing_msg_result_invalid_pay_info: `ข้อมูลการชำระเงินไม่ถูกต้อง`,
  billing_msg_result_pg_fail: `เติมแคชไม่สำเร็จ \nโปรดลองอีกครั้ง`,
  billing_msg_credit_info_not_exists: `ไม่มีข้อมูลการชำระเงิน`,
  billing_alert_check_agree: `โปรดยอมรับข้อกำหนดและเงื่อนไขการชำระเงิน`,
  billing_alert_invalid_price: `ข้อมูลจำนวนเงินไม่ถูกต้อง`,
  billing_alert_invalid_item_info: `ข้อมูลผลิตภัณฑ์ไม่ถูกต้อง`,
  billing_common_404: `ไม่พบหน้าที่ร้องขอ`,
  billing_msg_already_other_device_login: `คุณเข้าสู่ระบบบนอุปกรณ์อื่น บัญชีที่อุปกรณ์นี้จึงถูกออกจากระบบ`,
  billing_msg_invalid_access_logout: `ถูกออกจากระบบเนื่องจากการเข้าถึงที่ไม่ถูกต้อง`,
  billing_msg_already_login: `จำเป็นต้องเข้าสู่ระบบ`,
  billing_msg_web_unavailable: `เติมแคชได้ในแอปฯ เท่านั้น
คุณต้องการไปเปิดแอปฯ ไหม?`,
  billing_msg_pc_unavailable: `เติมแคชได้ในแอปฯ เท่านั้น
โปรดดาวน์โหลดแอปฯ ก่อน
`,
  billing_msg_first_puchase_only: `คุณได้ชำระเงินเกินจำนวนครั้งแล้ว`,
  library_tab_recent: `อ่านล่าสุด`,
  library_tab_recent_phrase_default: `ผลงานยอดฮิตรอคุณอยู่
ที่ KAKAO WEBTOON
มาสนุกกันเถอะ`,
  library_tab_recent_phrase_login_genre: `เพราะคุณ{{userid}}
อ่านแนว{{genre_1}}
เป็นประจำ`,
  library_tab_recent_phrase_popular: `{{genre_1}}
กำลังมาแรงในช่วงนี้เลย
ลองอ่านดูไหม?`,
  library_tab_recent_phrase_login_title: `เพราะคุณ{{userid}}
ชอบ{{title}}
เป็นเรื่องโปรด`,
  library_tab_recent_phrase_nonlogin_style: `มีผลงานที่ลายเส้นคล้าย
กับ{{title}}
ลองอ่านดูไหม?`,
  library_tab_recent_phrase_nonlogin_genre: `คุณสนุกกับเรื่องราวแนว
{{genre_1}}
ไปเมื่อเร็วๆ นี้`,
  library_tab_recent_phrase_nonlogin_title: `คุณสนุกกับเรื่อง
{{title}}
ไปเมื่อเร็วๆ นี้`,
  library_tab_recent_phrase_title: `คุณเพิ่งได้อ่าน
{{ชื่อ}}
ไปล่าสุด`,
  library_tab_recent_phrase_rec: `เว็บตูนเรื่องอื่นๆ
ของ Kakao Webtoon
เป็นอย่างไรบ้าง?`,
  library_tab_recent_empty: `ดูเรื่องที่อ่านเร็วๆ นี้ ได้ที่นี่`,
  library_see_all_button: `ดูทั้งหมด`,
  library_tab_recent_sort_recent: `เรียงตามชื่อเรื่อง`,
  library_tab_recent_sort_update: `เรียงตามวันที่อัปเดต`,
  library_tab_recent_sort_recent_toast: `เรียงตามชื่อเรื่อง`,
  library_tab_recent_sort_update_toast: `เรียงตามวันที่อัปเดต`,
  library_tab_recent_sort_download_toast: `เรียงตามลำดับการดาวน์โหลด`,
  library_tab_recent_sort_storage_toast: `เรียงตามหน่วยความจำ`,
  library_edit_button: `แก้ไข`,
  library_select_all_button: `เลือกทั้งหมด`,
  library_delete_episode_button: `ลบ {{count}} ตอน`,
  library_delete_episode_button_plural: `ลบ {{count}} ตอน`,
  library_delete_content_button: `ลบผลงาน {{count}} รายการ`,
  library_delete_content_button_plural: `ลบผลงาน {{count}} รายการ`,
  library_tab_recent_delete_popup: `ต้องการลบผลงานที่อ่านล่าสุด
{{count}} รายการ หรือไม่?`,
  library_tab_recent_delete_popup_plural: `ต้องการลบผลงานที่อ่านล่าสุด
{{count}} รายการ หรือไม่?`,
  library_tab_recent_delete_popup_v4: `คุณต้องการลบ {{value}} เรื่องที่อ่านล่าสุด ออกจากรายการของคุณ ใช่ไหม?`,
  library_tab_recent_delete_popup_plural_v4: `คุณต้องการลบ {{value}} เรื่องที่อ่านล่าสุด ออกจากรายการของคุณ ใช่ไหม?`,
  library_tab_recent_language_toast: `ต้องเปลี่ยนเป็นภาษา {{language}} เพื่ออ่านผลงานนี้"`,
  library_tab_recent_language_toast_v4: `ไม่สามารถอ่านได้ในภาษาปัจจุบัน`,
  library_tab_favorites: `ติดตาม`,
  library_tab_favorites_on: `ON`,
  library_tab_favorites_off: `OFF`,
  library_tab_favorites_device_popup: `การแจ้งเตือนของอุปกรณ์ปิดอยู่
ต้องการเปลี่ยนการตั้งค่าหรือไม่?`,
  library_tab_favorites_episode_popup: `เปิดการแจ้งเตือนอัปเดตตอนใหม่
เพื่อรับข่าวสารอัปเดตหรือไม่?`,
  library_tab_favorites_episode_popup_button: `เปิดการแจ้งเตือน`,
  library_tab_favorites_episode_toast: `รับแจ้งเตือนอัปเดตตอน`,
  library_before_login: `กรุณาเข้าสู่ระบบเพื่อใช้งาน`,
  library_tab_favorites_before_login: `เข้าสู่ระบบและกดติดตามเพื่อรับแจ้งเตือนอัปเดตตอนใหม่`,
  library_tab_empty: `กดติดตามเรื่องที่สนใจเพื่อรับแจ้งเตือนอัปเดตตอนใหม่`,
  library_tab_favorites_available_fav: `{{count}} รายการ
ผลงานที่ติดตาม
`,
  library_tab_favorites_available_fav_plural: `{{count}} รายการ
ผลงานที่ติดตาม
`,
  library_tab_favorites_available_update: `{{count}} รายการ
ผลงานอัปเดต
`,
  library_tab_favorites_available_update_plural: `{{count}} รายการ
ผลงานอัปเดต
`,
  library_tab_favorites_unavailable: `ไม่มีผลงานที่ติดตาม`,
  library_tab_favorites_sort_update: `เรียงตามวันที่อัปเดต`,
  library_tab_favorites_sort_added: `เรียงตามวันที่กดติดตาม`,
  library_tab_favorites_sort_update_toast: `เรียงตามวันที่อัพเดท`,
  library_tab_favorites_sort_added_toast: `เรียงตามวันที่กดหัวใจ`,
  library_tab_favorites_delete_title: `เรียงตามวันที่กดติดตาม`,
  library_tab_favorites_delete_popup: `ต้องการลบผลงานที่ติดตาม
{{count}} รายการ หรือไม่?`,
  library_tab_favorites_delete_popup_plural: `ต้องการลบผลงานที่ติดตาม
{{count}} รายการ หรือไม่?`,
  library_tab_downloads: `ดาวน์โหลด`,
  library_tab_download_available_episode: `{{count}} ตอน
ดาวน์โหลดแล้ว
`,
  library_tab_download_available_episode_plural: `{{count}} ตอน
ดาวน์โหลดแล้ว
`,
  library_tab_download_unavailable_series: `ไม่มีรายการ
ผลงานที่ดาวน์โหลดไว้`,
  library_tab_download_before_login: `เข้าสู่ระบบและดาวน์โหลดเพื่ออ่านในโหมดออฟไลน์`,
  library_tab_download_empty: `ดาวน์โหลดเพื่ออ่านในโหมดออฟไลน์`,
  library_tab_download_sort_download: `เรียงตามการดาวน์โหลด`,
  library_tab_download_sort_storage: `เรียงตามปริมาณ`,
  library_tab_download_refresh: `รีเฟรช`,
  library_delete_title_button: `ลบผลงาน {{value}} รายการ`,
  library_tab_download_free: `ฟรี`,
  library_tab_download_rent: `เช่า`,
  library_tab_download_possess: `ซื้อเก็บ`,
  library_tab_download_expired: `หมดอายุการเช่า`,
  library_tab_download_paid: `เปลี่ยนเป็นตอนที่ซื้อ`,
  library_tab_download_expired_toast: `หมดอายุการเช่า กรุณาดาวน์โหลดอีกครั้งเพื่ออ่าน`,
  library_tab_downloads_delete_popup: `ต้องการลบผลงานที่ดาวน์โหลด
{{count}} รายการ หรือไม่?`,
  library_tab_downloads_delete_popup_plural: `ต้องการลบผลงานที่ดาวน์โหลด
{{count}} รายการ หรือไม่?`,
  library_tab_downloads_delete_popup_v4: `ต้องการลบผลงานที่ดาวน์โหลด {{value}} รายการ หรือไม่?`,
  library_tab_downloads_delete_popup_plural_v4: `ต้องการลบผลงานที่ดาวน์โหลด {{value}} รายการ หรือไม่?`,
  library_tab_downloads_delete_ep_popup: `ต้องการลบตอนที่ดาวน์โหลด
{{count}} รายการ หรือไม่?`,
  library_tab_downloads_delete_ep_popup_plural: `ต้องการลบตอนที่ดาวน์โหลด
{{count}} รายการ หรือไม่?`,
  library_tab_downloads_delete_ep_popup_v4: `ต้องการลบตอนที่ดาวน์โหลด {{value}} รายการ หรือไม่?`,
  library_tab_downloads_delete_ep_popup_plural_v4: `ต้องการลบตอนที่ดาวน์โหลด {{value}} รายการ หรือไม่?`,
  library_tab_download_offline_toast: `ไม่สามารถไปต่อได้ในโหมดออฟไลน์`,
  library_tab_download_network_popup: `กรุณาตรวจสอบการเชื่อมต่อเครือข่าย
แล้วลองใหม่อีกครั้ง`,
  offline_download_empty_title: `ไม่มีผลงานที่ดาวน์โหลด`,
  offline_download_empty_episode: `ไม่มีตอนที่ดาวน์โหลด`,
  offline_download_network_toast: `กรุณาเชื่อมต่อเครือข่ายเพื่อใช้งาน`,
  error_network_popup_title: `ไม่มีการเชื่อมต่อเครือข่าย`,
  error_network_popup_content: `กรุณาตรวจสอบว่าเปิดโหมดเครื่องบินอยู่หรือไม่, 
เชื่อมต่อ Wi-Fi หรือใช้เซลลูลาร์ดาต้าได้หรือไม่ 
แล้วลองใหม่อีกครั้ง`,
  library_tab_possessed: `ซื้อ/เช่า`,
  library_tab_possessed_available: `{{count}} ตอน
ซื้อ/เช่าแล้ว`,
  library_tab_possessed_available_plural: `{{count}} ตอน
ซื้อ/เช่าแล้ว`,
  library_tab_possessed_unavailable_series: `ไม่มีรายการ ผลงานที่ซื้อ/เช่า`,
  library_tab_possessed_unavailable_episode: `ไม่มีตอนที่ซื้อ/เช่า`,
  library_tab_possessed_sort_update: `เรียงตามวันที่อัปเดต`,
  library_tab_possessed_sort_possessed: `เรียงตามวันที่แลกตั๋ว`,
  library_tab_possessed_sort_update_toast: `เรียงตามวันที่อัปเดต`,
  library_tab_possessed_sort_possessed_toast: `เรียงตามวันที่แลกตั๋ว`,
  library_tab_possessed_sort_episode_count: `ซื้อเก็บ {{count}} ตอน`,
  library_tab_possessed_sort_episode_count_plural: `ซื้อเก็บ {{count}} ตอน`,
  library_tab_possessed_sort_episode_free: `เปลี่ยนเป็นตอนฟรี`,
  library_tab_possessed_sort_episode_expired: `หมดอายุเช่า`,
  library_tab_possessed_empty: `ไม่มีตอนที่อ่านไปโดยใช้ตั๋วที่แลก`,
  library_tab_possessed_empty_ticket: `มีเหลืออยู่ {{count}} ตั๋ว`,
  library_tab_possessed_empty_ticket_plural: `มีเหลืออยู่ {{count}} ตั๋ว`,
  library_tab_possessed_empty_ticket_button: `ไปอ่านเว็บตูน`,
  library_tab_possessed_delete_popup_v4: `ผลงานที่คุณเลือกถูกซ่อนจากรายการแลกตั๋ว
หากต้องการดูรายชื่อผลงาน กดเปิด ในโหมดแก้ไข`,
  library_tab_possessed_deleted_toast: `ลบตอนที่ซื้อ/เช่าทั้งหมดแล้ว`,
  library_tab_possessed_episode_button: `{{count}} ตอน`,
  library_tab_possessed_episode_button_plural: `{{count}} ตอน`,
  library_hide_title_button: `ซ่อน {{count}} ผลงาน`,
  library_hide_title_button_plural: `ซ่อน {{count}} ผลงาน`,
  library_tab_possessed_delete_popup: `ต้องการซ่อนผลงานที่เช่า
{{count}} รายการ
ที่ชั้นหนังสือหรือไม่?
หากซื้อตั๋วจะปรากฏอีก`,
  library_tab_possessed_delete_popup_plural: `ต้องการซ่อนผลงานที่เช่า
{{count}} รายการ
ที่ชั้นหนังสือหรือไม่?
หากซื้อตั๋วจะปรากฏอีก`,
  library_tab_possessed_before_login: `เรื่องที่ซื้อ/เช่า`,
  library_tab_comments: `ความคิดเห็น`,
  library_tab_comments_unavailable: `ไม่มีความคิดเห็นที่เขียน`,
  library_tab_comments_delete_popup: `คุณต้องการจะลบ {{count}} ความคิดเห็นที่คุณเขียนหรือไม่?`,
  library_tab_comments_delete_popup_plural: `คุณต้องการจะลบ {{count}} ความคิดเห็นที่คุณเขียนหรือไม่?`,
  giftbox_cashfriend: `แคชที่เก็บได้ในตอนนี้`,
  giftbox_onboarding: `สมัครตอนนี้ รับตั๋วของขวัญ ไปอ่านเว็บตูนสุดฮิต ฟรี!`,
  giftbox_tab_event: `กิจกรรม`,
  giftbox_tab_event_participated: `ได้รางวัลแล้ว`,
  giftbox_tab_event_empty: `ไม่มีกิจกรรมที่สามารถเข้าร่วมได้`,
  giftbox_tab_event_empty_global: `ไม่มีกิจกรรม
ที่สามารถเข้าร่วมได้`,
  giftbox_ticket_gift: `ตั๋ว
ของขวัญ`,
  giftbox_tab_ticket_receive_button: `รับ {{count}} ตั๋ว`,
  giftbox_tab_ticket_receive_button_plural: `รับ {{count}} ตั๋ว`,
  luckydraw_ticket_button: `ไปอ่านเว็บตูน`,
  giftbox_tab_ticket_received: `รับแล้ว`,
  giftbox_tab_ticket_empty: `ไม่มีตั๋วของขวัญที่สามารถรับได้`,
  giftbox_tab_ticket_empty_global: `ไม่มีตั๋วของขวัญ
ที่สามารถรับได้`,
  giftbox_tab_ticket_empty_korea: `ไม่มีของขวัญ
ที่สามารถรับได้`,
  giftbox_tab_received_popup: `รับ {{count}} ตั๋วของขวัญแล้ว`,
  giftbox_tab_received_popup_plural: `รับ {{count}} ตั๋วของขวัญแล้ว`,
  giftbox_tab_received_valid_within_popup: `หมดอายุ: 3 วัน นับจากวันที่กดรับ`,
  search_title: `ค้นหา`,
  search_main_question: `กำลังมองหา
ผลงานแบบไหนอยู่?`,
  search_main_question_1_web: `กำลังมองหา`,
  search_main_question_2_web: `ผลงานแบบไหนอยู่?`,
  search_input_before_enter: `กรุณาใส่ชื่อผลงาน ชื่อนักเขียน หรือประเภท`,
  search_recent: `คำค้นหาล่าสุด`,
  search_recent_plural: `คำค้นหาล่าสุด`,
  search_result_empty: `"{{value}}"
ไม่พบผลลัพธ์ดังกล่าว`,
  search_result_empty_web: `ไม่พบผลลัพธ์ดังกล่าว`,
  notification_title: `แจ้งเตือน`,
  notification_tab_my: `ข่าวสารของฉัน`,
  notification_tab_gidamu: `รออ่านฟรี`,
  notification_tab_gidamu_complete: `อ่านฟรี 1 ตอน`,
  notification_before_login: `กรุณาเข้าสู่ระบบเพื่อใช้บริการ`,
  gidamu_notification_list_blank: `ไม่มีการแจ้งเตือนตั๋วรออ่านฟรี`,
  notification_list_blank: `ไม่มีการแจ้งเตือน`,
  notification_tab_notice: `ประกาศ`,
  notification_notice_list_deleted: `ประกาศนี้ถูกลบไปแล้ว`,
  notification_valid_specific_date: `หมดอายุ: {{value}}`,
  notification_expiry_bydate: `หมดอายุ: {{count}} วัน นับจากวันที่แจก`,
  notification_expiry_bydate_plural: `หมดอายุ: {{count}} วัน นับจากวันที่แจก`,
  notification_expiry_byhour: `หมดอายุ: {{count}} ชม. นับจากวันที่แจก`,
  notification_expiry_byhour_plural: `หมดอายุ: {{count}} ชม. นับจากวันที่แจก`,
  notification_expiry_specific_date: `หมดอายุ: จนถึง {{value}}`,
  notification_expiry_today: `หมดอายุ: ภายในวันนี้`,
  notification_expiry_hour: `หมดอายุ: 59นาทีจากเวลาที่กดรับ`,
  notification_tab_gidamu_delete_button: `ลบการแจ้งเตือน {{count}} รายการ`,
  notification_tab_gidamu_delete_button_plural: `ลบการแจ้งเตือน {{count}} รายการ`,
  notification_tab_gidamu_delete_popup_title: `คุณแน่ใจหรือไม่ว่าต้องการหยุดรับการแจ้งเตือนรออ่านฟรี {{count}} เรื่อง`,
  notification_tab_gidamu_delete_popup_title_plural: `คุณแน่ใจหรือไม่ว่าต้องการหยุดรับการแจ้งเตือนรออ่านฟรี {{count}} เรื่อง`,
  notification_tab_gidamu_delete_popup_content: `คุณจะได้รับแจ้งเตือนอีกครั้งเมื่อใช้ตั๋วรออ่านฟรีใบใหม่`,
  notification_push_waitandfree_title: `[รออ่านฟรี] {{value}}`,
  notification_push_waitandfree_content: `ไปอ่านฟรี 1 ตอนได้เลย!`,
  notification_push_ticket_expire_title: `ตั๋วหมดอายุ`,
  notification_push_ticket_expire_content: `{{count}} ตั๋วของเรื่อง {{title}} จะหมดอายุในวันนี้`,
  notification_push_ticket_expire_content_plural: `{{count}} ตั๋วของเรื่อง {{title}} จะหมดอายุในวันนี้`,
  notification_push_cash_expire_title: `แคชของขวัญใกล้หมดอายุแล้ว`,
  notification_push_cash_expire_content: `รีบไปแลกตั๋วด้วยแคชที่ใกล้หมดอายุ`,
  notification_push_title_update_title: `อัปเดต {{value}}`,
  notification_push_title_update_content_multiple: `'{{start}} ~ {{end}}' อัปเดตแล้ว`,
  notification_push_title_update_content_single: `'{{value}}' อัปเดตแล้ว`,
  notification_push_comment_like_title: `คุณ {{value}} ถูกใจความคิดเห็นของคุณ`,
  notification_push_comment_like_title_multiple: `คุณ{{count}} และอีก {{count}} คน ถูกใจความคิดเห็นของคุณ`,
  notification_push_comment_like_title_multiple_plural: `คุณ{{count}} และอีก {{count}} คน ถูกใจความคิดเห็นของคุณ`,
  notification_push_comment_reply_title: `มีการตอบกลับความคิดเห็นของคุณใน`,
  notification_push_comment_reply_content: `[{{content}} - {{episode}}]`,
  notification_push_comment_reply_event_content: `[{{value}}]`,
  notification_push_gift_ticket_content: `คุณได้รับตั๋วของขวัญ`,
  notification_push_gift_cash_content: `คุณได้รับ {{value}} แคช`,
  notification_push_gift_coupon_title: `[แลกคูปองสำเร็จ]`,
  notification_push_gift_slot_content: `เล่นสล็อตแมชชีนกันตอนนี้เลย`,
  notification_push_gift_luckydraw_title: `รางวัลสล็อตแมชชีนมาถึงแล้ว`,
  notification_push_gift_prize_title: `คุณได้รับ {{prize}}`,
  notification_push_gift_prize_content: `กรุณาแจ้งข้อมูลเพื่อรับรางวัลก่อนหมดเวลา`,
  notification_push_popup_title_update_deleted: `ไม่สามารถดูได้
เนื่องจากผลงานถูกลบไปแล้ว`,
  notification_push_popup_event_expired: `สิ้นสุดระยะเวลากิจกรรมแล้ว`,
  notification_push_popup_common_language: `ไม่สามารถเปลี่ยนหน้าได้เนื่องจากมีการเปลี่ยนภาษา
หากต้องการตรวจสอบประวัติการแจ้งเตือน กรุณาเปลี่ยนแปลงการตั้งค่าภาษา`,
  notification_raffle_page_title: `บัตรสุ่มมาแล้ว`,
  notification_raffle_received: `บัตรสุ่มถูกส่งถึงคุณแล้ว รอลุ้นเป็นผู้โชคดี รับรางวัลผ่านข้อความแจ้งเตือน`,
  notification_raffle_received_name: `บัตรสุ่ม`,
  notification_raffle_received_date: `วันที่ได้รับ`,
  more_menu: `เมนูด้านข้าง`,
  more_login_eng: `เข้าสู่ระบบ`,
  more_title_cash_add_auto_applied: `ได้สิทธิประโยชน์แคชแบ็ก {{value}}%`,
  more_title_cash_add_auto_unapplied: `สมัครการเติมแคชอัตโนมัติ มีสิทธิ์ได้รับแคชแบ็กสูงสุด {{value}}%`,
  more_title_coupon_redeem: `แลกคูปอง`,
  more_title_notification: `ข่าวสารของฉัน`,
  more_title_notice: `ประกาศ`,
  more_title_display_mode: `โหมดหน้าจอ`,
  more_title_display_mode_dark: `โหมดมืด`,
  more_title_display_mode_light: `โหมดสว่าง`,
  more_title_display_mode_system: `ตั้งค่าระบบ`,
  more_title_content_notification: `แจ้งเตือนผลงาน`,
  more_title_content_notification_before_login: `สามารถใช้ได้หลังเข้าสู่ระบบ`,
  more_title_content_notification_episode: `แจ้งเตือนอัปเดตตอน`,
  more_title_content_notification_gidamu: `แจ้งเตือนตั๋วรออ่านฟรี`,
  more_title_system_preferences: `การตั้งค่า`,
  more_title_system_preferences_autoplay: `เริ่มวิดีโอโดยอัตโนมัติ`,
  more_title_system_preferences_data: `อ่านเฉพาะเมื่อเชื่อมต่อกับ Wifi`,
  more_title_app_setting: `ตั้งค่า`,
  settings_title_web: `ตั้งค่า`,
  more_login_message: `กรุณาเข้าสู่ระบบ`,
  more_cash_add_auto_unapplied: `แคชแบ็กสูงสุด {{value}}%`,
  more_cashfriends: `แคชที่คุณมีโอกาส`,
  more_myinfo: `ข้อมูลของฉัน`,
  more_myinfo_nickname: `ชื่อเล่น`,
  more_myinfo_userid: `หมายเลขสมาชิก`,
  more_myinfo_userid_copy_toast: `คัดลอกแล้ว`,
  more_myinfo_account: `บัญชีของฉัน`,
  more_myinfo_logout_popup: `ต้องการออกจากระบบหรือไม่?`,
  more_myinfo_nickname_unknown: `ไม่ทราบชื่อ`,
  more_myinfo_nickname_change: `แก้ไขชื่อเล่น`,
  more_myinfo_nickname_enter: `กรุณาใส่ชื่อเล่น`,
  more_myinfo_nickname_limit_guide: `<white>{{value}}</white>/20`,
  more_myinfo_nickname_toast: `บันทึกแล้ว`,
  more_myinfo_nickname_banned_toast: `{{word}} : ไม่สามารถใช้ชื่อเล่นนี้ได้`,
  more_myinfo_nickname_emoticon: `ใส่ได้ 2-20 ตัวอักษรเป็นภาษาไทย ภาษาอังกฤษ ตัวเลข และอักษรพิเศษ (-) (_) เท่านั้น`,
  more_myinfo_nickname_change_button: `แก้ไข`,
  more_myinfo_nickname_length: `ใส่ได้ 2-20 ตัวอักษร`,
  more_myinfo_nickname_character: `ใส่ตัวอักษรภาษาไทย ภาษาอังกฤษ 
ตัวเลข และอักษรพิเศษ (-) (_) เท่านั้น`,
  more_myinfo_account_delete: `ลบบัญชี`,
  more_myinfo_account_delete_precautions: `ข้อควรระวังในการลบบัญชี`,
  more_myinfo_account_delete_precautions_detail_1: `บันทึกทั้งหมด เช่น ประวัติการเติมแคชและประวัติแลกตั๋ว จะถูกลบออกอย่างถาวรเมื่อมีการลบบัญชี และไม่สามารถกู้คืนได้`,
  more_myinfo_account_delete_precautions_detail_2: `ความคิดเห็นของคุณจะแสดงเป็น 'ความคิดเห็นของบัญชีที่ถูกลบ' หากคุณไม่ต้องการให้ความคิดเห็นของคุณปรากฏ โปรดลบความคิดเห็นของคุณก่อนที่จะลบบัญชี`,
  more_myinfo_account_delete_precautions_detail_3: `ตั๋วที่ไม่ได้ใช้และแคชที่เหลือจะหมดอายุเมื่อมีการลบบัญชีของคุณ`,
  more_myinfo_account_delete_precautions_detail_4: `แคชที่เหลือที่เรียกเก็บผ่านการชำระเงินในแอปไม่สามารถขอคืนใน Kakao Webtoon ได้ สำหรับการคืนเงิน โปรดสอบถามที่ร้านค้าแต่ละแห่ง (Google Play, App Store) ที่คุณเรียกเก็บเงิน`,
  more_myinfo_account_delete_precautions_detail_5: `คุณไม่สามารถลงทะเบียนใหม่ด้วยบัญชีเดิมได้ภายใน 30 วันนับจากวันที่ลบบัญชี`,
  more_myinfo_account_delete_agreed: `ฉันได้อ่านและยอมรับข้อควรระวัง`,
  more_myinfo_account_delete_button: `ลบบัญชี Kakao Webtoon`,
  more_myinfo_account_delete_confirm_popup: `เมื่อลบบัญชีแล้ว ประวัติแคชและตั๋ว หรือประวัติการใช้บริการอื่นๆ จะถูกลบทันที คุณแน่ใจหรือว่าต้องการลบ`,
  more_myinfo_account_delete_toast: `บัญชีถูกลบเรียบร้อยแล้ว`,
  more_help: `ความช่วยเหลือ`,
  more_help_faq: `คำถามที่พบบ่อย`,
  more_customer: `ติดต่อทีมงาน`,
  more_customer_rights_report: `คำแนะนำเรื่องรายงานการละเมิดสิทธิ`,
  more_customer_title_inquiry: `สอบถาม`,
  more_customer_inquiry: `ติดต่อทีมงาน`,
  more_customer_inquiry_global_title: `[Help] สอบถามมายัง KAKAO WEBTOON`,
  more_customer_inquiry_global_question_1: `อยากสอบถามเรื่องใด (ปัญหาที่พบ, ข้อเสนอแนะ)`,
  more_customer_inquiry_global_question_2: `อยากสอบถามเรื่องใด (กรุณาอธิบายปัญหา ขั้นตอน วิธีการ และความถี่ในการเกิดปัญหาอย่างละเอียดและชัดเจน)`,
  more_customer_inquiry_global_question_3: `หากแนบคลิปวิดีโอหรือภาพหน้าจอของปัญหา จะช่วยแก้ไขได้เร็วขึ้น เวลารับแจ้งปัญหาสำหรับช่องทางอีเมลคือ จันทร์-ศุกร์ 08.00-18.00 น.`,
  more_customer_inquiry_info_id: `หมายเลขสมาชิก`,
  more_customer_inquiry_info_version_app: `เวอร์ชันแอป`,
  more_customer_inquiry_info_browser: `เบราว์เซอร์`,
  more_customer_inquiry_info_device: `ชื่ออุปกรณ์`,
  more_customer_inquiry_info_device_language: `ภาษาอุปกรณ์`,
  more_customer_inquiry_info_version_ios: `iOS Version`,
  more_customer_inquiry_info_version_aos: `Android version`,
  more_customer_inquiry_global_agreement_notice: `การส่งคำถามทางอีเมลข้างต้นถือว่าคุณยอมรับนโยบายความเป็นส่วนตัวและข้อกำหนดในการให้บริการของบริษัท `,
  more_customer_support_email_address: `cs.th@kakaoent.com`,
  more_customer_support_email_address_th: `cs.th@kakaoent.com`,
  more_customer_support_email_address_tw: `support_tw@kakaowebtoon.com `,
  more_customer_inquiry_category_refund_ticket: `สอบถามการคืนตั๋ว`,
  more_customer_inquiry_category_refund_cash: `สอบถามการคืนแคช`,
  more_customer_inquiry_category_report_rights: `รายงานการละเมิดสิทธิ`,
  more_customer_inquiry_category_general: `สอบถามทั่วไป`,
  more_customer_inquiry_category_suggestions: `แนะนำ/ติชม`,
  more_customer_inquiry_category_problems: `ปัญหาจากการใช้งาน`,
  more_customer_inquiry_category_cashfriends_level: `สอบถามเรื่องแคชเฟรนด์ (ประเภทบรรลุเลเวล)`,
  more_customer_inquiry_category_cashfriends_join: `สอบถามเรื่องแคชเฟรนด์ (ประเภทสมัคร)`,
  more_customer_inquiry_category_cashfriends_other: `สอบถามเรื่องแคชเฟรนด์ (ประเภทติดตั้ง, ดำเนินการ, ลงทะเบียนล่วงหน้า)`,
  more_customer_inquiry_guide_ID: `เลขสมาชิก KAKAO:`,
  more_customer_inquiry_guide_ID_detail: `ตรวจสอบได้ที่ 'ข้อมูลของฉัน'`,
  more_customer_inquiry_guide_refund_series: `ชื่อผลงานที่ต้องการคืน:`,
  more_customer_inquiry_guide_refund_price: `ยอดแคช:`,
  more_customer_inquiry_guide_refund_platform: `ช่องทางการชำระ (App/Web):`,
  more_customer_inquiry_guide_refund_reason: `เหตุผลในการคืน:`,
  more_customer_inquiry_guide_inquiries: `รายละเอียด:`,
  more_customer_inquiry_guide_report: `กรุณาใส่ข้อมูลของคอนเทนต์ที่ต้องการรายงานให้ชัดเจน`,
  more_customer_inquiry_guide_account: `บัญชี KAKAO:`,
  more_customer_inquiry_guide_report_episode: `ชื่อผลงาน/ตอนที่จะรายงาน:`,
  more_customer_inquiry_guide_report_publisher: `ผู้เผยแพร่ผลงาน/ตอนที่จะรายงาน:`,
  more_customer_inquiry_guide_questions: `หัวข้อคำถาม:`,
  more_customer_inquiry_guide_suggestions: `ข้อแนะนำติชม:`,
  more_customer_inquiry_guide_problems_date: `วัน-เวลาที่เกิดปัญหา:`,
  more_customer_inquiry_guide_problems_detail: `รายละเอียดปัญหา:`,
  more_customer_inquiry_guide_participated_date: `วันที่เข้าร่วม:`,
  more_customer_inquiry_guide_participated_name: `ชื่อกิจกรรมที่เข้าร่วม:`,
  more_customer_inquiry_guide_purchase_date: `วันที่ซื้อ:`,
  more_customer_inquiry_guide_purchase_product: `ชื่อผลงานที่ซื้อ:`,
  more_customer_inquiry_guide_purchase_number: `หมายเลขการสั่งซื้อ:`,
  more_customer_inquiry_guide_name: `ชื่อ:`,
  more_customer_inquiry_guide_birthdate: `วันเดือนปีเกิด`,
  more_customer_inquiry_refund_ticket_input_detail: `*ตั๋วฟรีนั้นไม่สามารถยกเลิกได้ และกรณีของตั๋วที่แลกด้วยแคชของขวัญ 
จะไม่สามารถคืนได้เมื่อแคชหมดอายุไปแล้ว`,
  more_customer_inquiry_answer_number: `เบอร์โทรสำหรับรับการติดต่อ`,
  more_customer_inquiry_answer_number_error: `กรุณาใส่เบอร์โทรศัพท์ให้ถูกต้อง`,
  more_customer_inquiry_answer_email: `อีเมลสำหรับรับการติดต่อ`,
  more_customer_inquiry_answer_email_error: `กรุณาใส่ที่อยู่อีเมลให้ถูกต้อง`,
  more_customer_inquiry_attachment: `เพิ่มไฟล์แนบ`,
  more_customer_inquiry_attachment_button: `เพิ่ม`,
  more_customer_inquiry_attachment_detail_2: `เฉพาะสกุลไฟล์ jpg, png, pdf, zip เท่านั้น`,
  more_customer_inquiry_agreement_title: `แจ้งการยินยอมและรายละเอียดการเก็บข้อมูลส่วนบุคคล`,
  more_customer_inquiry_agreement_1: `เก็บข้อมูลเบอร์โทรศัพท์และอีเมล เพื่อการตรวจสอบสาเหตุและให้คำแนะนำเกี่ยวกับสิ่งที่สอบถาม`,
  more_customer_inquiry_agreement_2: `อาจมีการเก็บข้อมูลวันเดือนปีเกิด, ข้อมูลอุปกรณ์ และตัวระบุเพื่อการโฆษณา (ADID,IDFA) เป็นการเพิ่มเติม ขึ้นอยู่กับประเภทการสอบถาม`,
  more_customer_inquiry_agreement_3: `ข้อมูลส่วนตัวที่เก็บจะถูกเก็บรักษาไว้เป็นเวลา 3 ปี นับจากวันที่สอบถาม แล้วจึงถูกทำลายทิ้ง`,
  more_customer_inquiry_agreement_check: `ฉันยินยอมตามเนื้อหาข้างต้นทั้งหมด`,
  more_customer_inquiry_send_button: `ส่ง`,
  more_customer_inquiry_send_toast: `ส่งการสอบถามแล้ว`,
  more_customer_inquiry_history: `การสอบถาม`,
  more_customer_inquiry_history_detail: `ค้นประวัติได้สูงสุดในรอบหนึ่งปี`,
  more_customer_inquiry_history_empty: `ไม่มีประวัติการสอบถาม`,
  more_serviceinfo: `ข้อมูลบริการ`,
  more_serviceinfo_terms: `เงื่อนไขและนโยบาย`,
  more_serviceinfo_terms_cookie: `นโยบายคุกกี้`,
  more_serviceinfo_terms_use: `เงื่อนไขการใช้งาน`,
  more_serviceinfo_terms_personal: `นโยบายความเป็นส่วนตัว`,
  more_serviceinfo_terms_youth: `นโยบายคุ้มครองเยาวชน`,
  more_serviceinfo_terms_operational: `นโยบายการปฏิบัติการ`,
  more_serviceinfo_terms_payment: `เงื่อนไขการใช้งานแบบมีค่าบริการ`,
  more_serviceinfo_terms_payment_policy: `นโยบายเกี่ยวกับบริการชำระเงิน`,
  more_serviceinfo_terms_customized: `แจ้งการนำเสนอคอนเทนต์และโฆษณา
แบบระบุเป้าหมาย`,
  more_serviceinfo_openlicense: `การอนุญาตให้ใช้แบบเปิด`,
  more_serviceinfo_business: `ข้อมูลนิติบุคคล`,
  more_serviceinfo_business_name_company: `ชื่อทางการค้า`,
  more_serviceinfo_business_name_corporation: `Kakao Entertainment 
Corporation`,
  more_serviceinfo_business_name_representative: `ประธานเจ้าหน้าที่บริหารร่วม`,
  more_serviceinfo_business_name_representative_detail: `Kisu Kweon, Joseph Chang`,
  more_serviceinfo_business_registration_number: `เลขทะเบียนนิติบุคคล`,
  more_serviceinfo_business_registration_number_detail: `220-88-02594`,
  more_serviceinfo_business_mail_order: `รายงานธุรกิจเสนอขายผ่านทางโทรศัพท์`,
  more_serviceinfo_business_mail_order_detail: `2018-Seongnam Bundang B-0004`,
  more_serviceinfo_business_address: `ที่อยู่`,
  more_serviceinfo_business_address_detail: `Gyeonggido Seognamsi 
Bundanggu Pangyo 221`,
  more_serviceinfo_business_phone: `เบอร์ติดต่อ`,
  more_serviceinfo_business_phone_detail: `1644-4755`,
  more_serviceinfo_business_email: `อีเมล`,
  more_serviceinfo_business_email_detail: `contact@kakaoent.com`,
  more_serviceinfo_business_host: `ผู้ให้บริการโฮสต์ติง`,
  more_serviceinfo_version: `แจ้งเวอร์ชั่นแอป`,
  more_serviceinfo_version_latest: `เวอร์ชั่นล่าสุด`,
  more_serviceinfo_version_current: `เวอร์ชั่นปัจจุบัน`,
  more_serviceinfo_version_update: `อัปเดตเวอร์ชั่นล่าสุด`,
  more_serviceinfo_version_latest_inuse: `เป็นเวอร์ชั่นล่าสุดแล้ว`,
  more_serviceinfo_version_minsdk_change_title: `แจ้งข้อมูล เวอร์ชันขั้นต่ำของระบบปฏิบัติการ ที่รองรับการอัปเดต`,
  more_serviceinfo_version_minsdk_change_content: `เพื่อการใช้บริการที่เสถียรและราบรื่นยิ่งขึ้น เวอร์ชันขั้นต่ำของระบบปฏิบัติการ ที่รองรับการอัปเดต จึงเพิ่มขึ้นเป็น {{value}}

ไม่สามารถอัปเดตแอปฯ ได้สำหรับเวอร์ชันที่ต่ำกว่า {{value}} และโปรดเข้าใจว่าบริการนี้จะไม่สามารถใช้งานได้หากคุณจะมีการยกเลิกการใช้งานแอปฯ ในภายหลัง`,
  more_serviceinfo_version_minsdk_changed_title: `แจ้งการยกเลิกการสนับสนุนเวอร์ชันเก่า`,
  more_serviceinfo_version_minsdk_changed_content: `คุณสามารถดูตอนที่ซื้อและขอแลกคืนตั๋ว ได้บนเว็บไซต์ Kakao Webtoon เท่านั้น
โปรดเข้าใจว่า ทั้งนี้ เพื่อเป็นการให้บริการที่เสถียรมากยิ่งขึ้น`,
  more_serviceinfo_version_minsdk_changed_gotoweb: `ไปที่หน้าเว็บ`,
  redeem_coupon_before_enter: `กรุณาใส่รหัสคูปอง`,
  redeem_coupon_before_register_button: `แลก`,
  redeem_coupon_policy: `ข้อควรระวังในการแลกคูปอง`,
  redeem_coupon_inquiry: `ติดต่อทีมงาน`,
  redeem_coupon_policy_detail_1: `แลกไม่ได้เมื่อหมดอายุแล้ว`,
  redeem_coupon_policy_detail_2: `คูปองที่แลกไม่สามารถเปลี่ยน คืน หรือเปลี่ยนเป็นเงินสดได้`,
  redeem_coupon_policy_detail_3: `ตรวจสอบวันหมดอายุของคูปองที่แลกได้ที่ 
'ดูเพิ่มเติม > ประวัติการเติมแคช'`,
  redeem_coupon_policy_detail_3_v4: `ตรวจสอบวันหมดอายุของคูปองที่แลกได้ที่ 'เมนูด้านข้าง' > 'แจ้งเตือน'`,
  redeem_coupon_toast_success: `แลกคูปองสำเร็จ
ตรวจสอบคูปองที่แลกได้ที่ 'ข่าวสารของฉัน'`,
  redeem_coupon_toast_fail_invalid_checkagain: `หมายเลขคูปองไม่ถูกต้อง 
กรุณาตรวจสอบอีกครั้ง`,
  redeem_coupon_toast_fail_used: `คูปองนี้ถูกใช้ไปแล้ว`,
  redeem_coupon_toast_fail_sametype: `สามารถแลกคูปองประเภทเดียวกันได้
เพียง 1 ครั้งเท่านั้น`,
  redeem_coupon_toast_fail_ineligible: `ไม่ตรงเงื่อนไขของคูปอง`,
  redeem_coupon_toast_fail_expired: `คูปองนี้หมดอายุแล้ว`,
  redeem_coupon_toast_fail_invalid: `ไม่พบคูปองนี้`,
  redeem_coupon_toast_fail_ranout: `คูปองสำหรับการแจกหมดแล้ว`,
  redeem_coupon_toast_fail_used_device: `คุณเคยแลกคูปองนี้บนอุปกรณ์นี้แล้ว`,
  settings_title: `ตั้งค่า`,
  settings_system_preferences: `ตั้งค่าการใช้งาน`,
  settings_notifications: `ตั้งค่าแจ้งเตือน`,
  settings_notifications_content: `ปิดการแจ้งเตือนทั้งหมดอยู่`,
  settings_notifications_device: `ตั้งค่าแจ้งเตือนอุปกรณ์`,
  settings_notifications_device_detail: `รับการแจ้งเตือนจากแอปฯ`,
  settings_notifications_toast: `ใช้งานได้หลังจากเปิด
การแจ้งเตือนของอุปกรณ์`,
  settings_notifications_aos_toast: `ใช้งานได้หลังจากเปิดรับ
การแจ้งเตือนทั้งหมด`,
  settings_notifications_ios_popup: `ไปหน้าตั้งค่า
เพื่อเปลี่ยนการแจ้งเตือนของอุปกรณ์`,
  settings_notifications_marketing: `แจ้งเตือนกิจกรรมและแนะนำผลงาน`,
  settings_notifications_marketing_detail: `รับการแนะนำผลงานและแจ้งเตือนกิจกรรม`,
  settings_notifications_marketing_detail_320: `รับการแนะนำผลงาน
และแจ้งเตือนกิจกรรม`,
  settings_notifications_marketing_on_toast: `รับแจ้งเตือนการแนะนำผลงาน
และกิจกรรมของ KAKAO WEBTOON
เมื่อ {{value}}`,
  settings_notifications_marketing_on_toast_320: `รับแจ้งเตือนการแนะนำผลงาน
และกิจกรรมของ 
KAKAO WEBTOON
เมื่อ {{value}}`,
  settings_notifications_marketing_off_toast: `ปฏิเสธรับแจ้งเตือนการแนะนำผลงาน
และกิจกรรมของ KAKAO WEBTOON
เมื่อ {{value}}`,
  settings_notifications_marketing_off_toast_320: `ปฏิเสธรับแจ้งเตือน
การแนะนำผลงาน
และกิจกรรมของ 
KAKAO WEBTOON
เมื่อ {{value}}`,
  settings_notifications_device_off: `แจ้งเตือนของอุปกรณ์ปิดอยู่\nโปรดเปิดใช้งานการแจ้งเตือน`,
  settings_notifications_login_toast: `กรุณาเข้าสู่ระบบเพื่อใช้งาน`,
  settings_notifications_updates: `แจ้งเตือนการอัปเดตตอน`,
  settings_notifications_updates_detail: `รับแจ้งเตือนการอัปเดตตอนใหม่
ของผลงานที่ติดตาม`,
  settings_notifications_ticket: `แจ้งเตือนรับตั๋วรออ่านฟรี`,
  settings_notifications_likes_comment_global: `แจ้งเตือนถูกใจความคิดเห็น`,
  settings_notifications_likes_reply_global: `แจ้งเตือนการตอบกลับความคิดเห็น`,
  settings_notifications_likes_reply_global_320: `แจ้งเตือน
การตอบกลับความคิดเห็น`,
  settings_notifications_sleepmode_global: `ตั้งค่าโหมดพัก`,
  settings_notifications_sleepmode_global_info: `ไม่รับการแจ้งเตือนในช่วงเวลาที่กำหนด`,
  settings_notifications_sleepmode_global_start: `เวลาเริ่มโหมดพัก`,
  settings_notifications_sleepmode_global_end: `เวลาสิ้นสุดโหมดพัก`,
  settings_notifications_sleepmode_global_pm: `{{time}} PM`,
  settings_notifications_sleepmode_global_am: `{{time}} AM`,
  settings_data: `ตั้งค่าข้อมูล`,
  settings_data_wifi_view: `อ่านเว็บตูน เมื่อเชื่อมต่อ Wi-Fi เท่านั้น`,
  settings_data_wifi_download: `ดาวน์โหลด เมื่อเชื่อมต่อ Wi-Fi เท่านั้น`,
  settings_autoplay: `เล่นวิดีโออัตโนมัติ`,
  settings_autoplay_on: `เปิด`,
  settings_autoplay_off: `ปิด`,
  login_register_device_popup: `กรุณาเข้าสู่ระบบ
เพื่อลงทะเบียนอุปกรณ์`,
  settings_device_empty: `ไม่มีอุปกรณ์ที่ลงทะเบียนอยู่`,
  settings_device_registered: `ลงทะเบียนไว้ {{value}} เครื่อง`,
  settings_device_register: `ลงทะเบียนอุปกรณ์`,
  settings_device_deregister: `ยกเลิกอุปกรณ์`,
  settings_device_register_success_toast: `ลงทะเบียนอุปกรณ์แล้ว`,
  settings_device_register_fail_toast: `การลงทะเบียนอุปกรณ์ล้มเหลว 
กรุณาลองอีกครั้ง`,
  settings_device_registered_toast: `อุปกรณ์นี้ได้รับการลงทะเบียนแล้ว`,
  settings_device_deregister_toast: `ยกเลิกอุปกรณ์แล้ว`,
  settings_device_register_continue_popup_title: `ต้องการยกเลิกอุปกรณ์นี้หรือไม่?`,
  settings_device_register_continue_popup_content: `จำนวนครั้งการยกเลิกอุปกรณ์
ของเดือนนี้จะลดลง`,
  settings_device_register_impossible_popup: `ไม่สามารถยกเลิกอุปกรณ์ได้ 
เนื่องจากครบตาม
จำนวนครั้งที่กำหนดแล้ว`,
  settings_device_detail_1: `กรุณาลงทะเบียนอุปกรณ์เพื่อดาวน์โหลดตอน`,
  settings_device_detail_2: `ลงทะเบียนอุปกรณ์ได้เพียง 2 เครื่องต่อ ID`,
  settings_device_detail_3: `ยกเลิกอุปกรณ์ได้เพียง 1 ครั้งต่อเดือน 
(ยกเลิกได้อีก {{value}} ครั้ง)`,
  settings_device_detail_4: `เมื่อเกินจำนวนครั้งที่ยกเลิกอุปกรณ์ได้แล้วในเดือนนี้ 
จะสามารถลงทะเบียน/ยกเลิก ได้ใหม่
ตั้งแต่วันที่ 1 ของเดือนถัดไป`,
  settings_device_info_in_use_registered: `กำลังใช้อุปกรณ์ที่ลงทะเบียน`,
  settings_device_info_in_use_unregistered: `กำลังใช้อุปกรณ์อื่นที่เชื่อมต่อกับบัญชี`,
  settings_device_registered_date: `ลงทะเบียนเมื่อ {{date}}`,
  settings_device_info_deregister_button: `ยกเลิก`,
  settings_tracking_ios: `อนุญาตการติดตาม`,
  settings_tracking_ios_popup: `เมื่อเปิดอนุญาตติดตาม
จะมีโอกาสได้รับรางวัลมากขึ้น
ต้องการเปิดใช้งานหรือไม่?`,
  settings_tracking_on_ios_toast: `คุณสามารถเปลี่ยนการตั้งค่า
การอนุญาตการติดตามได้ใน
การตั้งค่าอุปกรณ์ > KAKAO WEBTOON`,
  settings_tracking_on_ios_oldversion_toast: `ใช้งานได้ในเวอร์ชัน 
iOS 14 ขึ้นไป`,
  settings_language: `ตั้งค่าภาษา`,
  settings_language_popup_title: `ต้องการเปลี่ยนเป็น
ภาษา {{language}} หรือไม่?`,
  settings_language_popup_content: `ผลงานที่สามารถอ่านได้อาจมีการเปลี่ยนแปลง`,
  settings_language_popup_content_app: `หากเปลี่ยนภาษา ผลงานที่อ่านอาจมีการเปลี่ยนแปลง โปรดปิดและเปิดแอปฯ ใหม่อีกครั้ง เพื่อเสร็จสิ้นการเปลี่ยนแปลงภาษาทั้งหมด`,
  settings_language_popup_content_web: `หากเปลี่ยนภาษา ผลงานที่อ่านอาจมีการเปลี่ยนแปลง`,
  region_language_change_settings_popup: `รีสตาร์ตแอปเพื่อการเปลี่ยนแปลงภาษาทั้งหมด`,
  settings_manage_space: `จัดการพื้นที่จัดเก็บ`,
  common_stroage_used_kb: `<bold>{{used}} KB</bold> / {{max}} GB`,
  common_stroage_used_mb: `<bold>{{used}} MB</bold> / {{max}} GB`,
  common_stroage_used: `<bold>{{used}} GB</bold> / {{max}} GB`,
  settings_manage_space_delete_downloads_button: `ลบทั้งหมดที่ดาวน์โหลด`,
  settings_manage_space_delete_downloads_popup_title: `ต้องการลบคอนเทนต์
ที่ดาวน์โหลดทั้งหมดหรือไม่?`,
  settings_manage_space_delete_downloads_popup_content: `ลบแยกตามรายการได้
ที่แท็บ 'ชั้นวางหนังสือ > ดาวน์โหลด'`,
  settings_manage_space_delete_cash_button: `ลบข้อมูลแคช`,
  settings_manage_space_delete_cash_toast: `ลบข้อมูลแคชทั้งหมดแล้ว`,
  settings_manage_space_autodelete: `ตั้งค่าเวลาลบอัตโนมัติ`,
  settings_manage_space_autodelete_10d: `10วัน`,
  settings_manage_space_autodelete_popup_title: `ต้องการเปลี่ยนระยะเวลา
การลบโดยอัตโนมัติ
เป็น 10 วัน หรือไม่?`,
  settings_manage_space_autodelete_popup_content: `หากเปลี่ยน คอนเทนต์
ที่เกิน 10 วันแล้วจะถูกลบทันที`,
  settings_viewer: `ตั้งค่าการอ่าน`,
  settings_viewer_sort: `การเรียงตอน`,
  settings_viewer_sort_date: `ตอนล่าสุด`,
  settings_viewer_sort_episode: `ตอนแรก`,
  settings_viewer_type: `ประเภทการแสดงตอน`,
  settings_viewer_type_thumbnai: `ประเภทรูปขนาดย่อ`,
  settings_viewer_type_list: `ประเภทรายการ`,
  settings_viewer_resolution: `ตั้งค่าคุณภาพตัวอ่าน`,
  settings_viewer_resolution_high: `คุณภาพสูง`,
  settings_viewer_resolution_low: `คุณภาพต่ำ`,
  settings_display_mode: `โหมดหน้าจอ`,
  settings_display_mode_dark: `โหมดมืด`,
  settings_display_mode_light: `โหมดสว่าง`,
  settings_display_mode_system: `ตั้งค่าระบบ`,
  login_auto_toast: `กำลังดำเนินการเข้าสู่ระบบโดยอัตโนมัติ กรุณาลองใหม่ในอีกสักครู่`,
  login_adult_toast: `ผลงานนี้มีเนื้อหาที่ไม่เหมาะสมกับเยาวชน จึงไม่สามารถเข้าอ่านได้`,
  login_popup: `กรุณาเข้าสู่ระบบเพื่อใช้งาน`,
  login_action_adult_popup: `กรุณาเข้าสู่ระบบ
เพื่อเข้าถึงผลงาน 18+`,
  login_action_view_gidamu_episode_popup: `กรุณาเข้าสู่ระบบ
เพื่ออ่านตอนแบบรออ่านฟรี`,
  login_action_view_next_ep_popup: `กรุณาเข้าสู่ระบบ
เพื่ออ่านต่อ`,
  deleted_account_popup: `ไม่สามารถสมัครเข้าใช้งานอีกครั้งได้ 
เนื่องจากเป็นบัญชีที่ยกเลิกการเป็นสมาชิกKAKAO WEBTOON ในช่วง 30 วันที่ผ่านมา`,
  inactive_user_popup_title: `กรุณาปลดสถานะหยุด เพื่อใช้บริการเข้าสู่ระบบ`,
  inactive_user_popup_content: `บัญชีของคุณเข้าสู่สถานะหยุดชั่วคราว เนื่องจากคุณไม่ได้เข้าสู่ระบบนานเกิน 1 ปี กรุณาปลดสถานะหยุด เพื่อใช้บริการเข้าสู่ระบบ โดยกดปุ่มตกลงเพื่อปลดสถานะหยุด`,
  blocked_user_popup_title: `คุณถูกระงับการเข้าสู่ระบบตามนโยบายการปฏิบัติการ`,
  blocked_user_popup_content: `กรุณาติดต่อทีมงานเพื่อสอบถามสาเหตุการระงับ
และขอยกเลิกการระงับ`,
  blocked_user_popup_content_cs: `<link_cs> ติดต่อทีมงาน KAKAO WEBTOON </link_cs>`,
  new_user_login_popup_web: `เป็นสมาชิกใหม่ใช่ไหม?
เปิดบนแอปฯ รับของขวัญเลย!`,
  new_user_login_popup_button_web: `ดำเนินการต่อในแอปฯ`,
  new_user_login_popup_continue_web: `ดำเนินการต่อในเว็บ`,
  login_global_onboarding_popup: `กรุณาเข้าสู่ระบบ/สมัครบัญชี
เพื่อเริ่มใช้งาน KAKAO WEBTOON`,
  login_global_gidamu_popup: `กรุณาเข้าสู่ระบบ/สมัครบัญชี
เพื่ออ่านตอนแบบรออ่านฟรี`,
  login_global_popup: `กรุณาเข้าสู่ระบบเพื่อใช้บริการ`,
  login_global_existing_account_popup: `คุณเคยเข้าสู่ระบบด้วย {{existing}} แล้ว`,
  login_global_account_google: `เข้าสู่ระบบด้วยบัญชี Google`,
  login_global_account_apple: `เข้าสู่ระบบด้วย Apple`,
  login_global_account_facebook: `เข้าสู่ระบบด้วย Facebook`,
  login_global_account_line: `เข้าสู่ระบบด้วย LINE`,
  login_global_account_twitter: `เข้าสู่ระบบด้วย Twitter`,
  login_global_existing_other_option_button: `ดูตัวเลือกอื่น`,
  login_global_existing_different_signin_button: `เข้าสู่ระบบด้วยบัญชีอื่น`,
  login_global_create_account_popup: `สมัครบัญชีเพื่ออ่านต่อ`,
  login_global_have_account_popup: `มีบัญชีหรือยัง?`,
  login_signin_button: `เข้าสู่ระบบ`,
  login_signup_page_title: `สมัคร`,
  login_signup_description_title: `สมัคร KAKAO WEBTOON`,
  login_signup_description_content: `แล้วมาสนุกกับเรื่องราวอย่างไร้ที่สิ้นสุด`,
  login_signup_agree_all: `ยินยอมทั้งหมด`,
  login_new_signup_button: `สมัคร KAKAO WEBTOON`,
  login_global_signup_agree_termsofuse: `ยินยอมตามเงื่อนไขการใช้งานของ KAKAO WEBTOON <grey>(จำเป็น)</grey>`,
  login_global_signup_termsofuse_page_title: `เงื่อนไขในการใช้งาน`,
  login_global_signup_agree_privacy: `ยินยอมตามนโยบายความเป็นส่วนตัวของ KAKAO WEBTOON <grey>(จำเป็น)</grey>`,
  login_global_signup_privacy_page_title: `นโยบายความเป็นส่วนตัว`,
  login_global_signup_agree_data_transfer: `ยอมรับการถ่ายโอนข้อมูลส่วนบุคคลระหว่างประเทศ (โปรดดูรายละเอียดที่ นโยบายความเป็นส่วนตัว) <grey>(จำเป็น)</grey>`,
  login_global_signup_agree_age: `ฉันอายุมากกว่า 10 ปี <grey>(จำเป็น)</grey>`,
  login_global_signup_agree_required_sentence: `กรุณายินยอมตามเงื่อนไขข้างต้น`,
  login_another_device_popup: `มีการเข้าสู่ระบบด้วยอุปกรณ์อื่นแล้ว
ต้องการยกเลิกการลงทะเบียนในอุปกรณ์อื่นและเข้าถึงด้วยอุปกรณ์นี้หรือไม่?`,
  login_global_signedup_web: `ลงทะเบียนในภาษาอื่นแล้ว ต้องการไปที่หน้าเว็บไซต์ของภาษาที่สมัครไว้หรือไม่`,
  login_global_signedup_web_button: `ไปหน้าเว็บไซต์`,
  login_global_signedup_app: `ภาษาที่ลงทะเบียนแตกต่างจากภาษาปัจจุบัน ระบบกำลังดำเนินการเปลี่ยนภาษาทั้งหมด โปรดปิดและเปิดแอปฯอีกครั้งเพื่อตรวจสอบภาษาที่เปลี่ยนแล้ว`,
  login_global_signedup_app_button: `เปิดแอปฯอีกครั้ง`,
  login_global_signedup_region_popup: `บัญชีที่คุณสมัครใช้งาน เป็นบัญชีสำหรับภูมิภาคที่อยู่ ณ ปัจจุบัน {{region}} คุณแน่ใจหรือไม่ว่าต้องการเปลี่ยนเป็นบริการในภูมิภาคส่วนตัวของคุณ? แอปจะถูกปิดเมื่อมีการเปลี่ยนแปลงภูมิภาค`,
  login_global_signedup_region_popup_button: `เปลี่ยนแปลงภูมิภาค `,
  region_country_select_taiwan: `台灣`,
  region_country_select_thailand: `ไทย`,
  region_country_select_france: `ฝรั่งเศส`,
  region_country_select_indonesia: `Indonesia`,
  region_country_select_korea: `한국`,
  login_forced_logout_popup: `คุณออกจากระบบแล้ว เนื่องจากมีการเข้าสู่ระบบด้วยอุปกรณ์อื่น`,
  login_restricted_popup_title: `คุณถูกระงับการเข้าสู่ระบบและการสมัครบัญชีชั่วคราว`,
  login_restricted_popup_content: `บัญชีของคุณเข้าสู่ระบบในอุปกรณ์หลายเครื่อง 
จึงถูกจำกัดการเข้าสู่ระบบ กรุณาเข้าสู่ระบบโดยใช้บัญชีเดิม
หากต้องการสมัครบัญชีใหม่หรือเข้าสู่ระบบด้วยบัญชีใหม่ กรุณาติดต่อทีมงาน`,
  login_restricted_help_popup: `ต้องการความช่วยเหลือ? <bold-link_cs>ติดต่อทีมงาน</bold-link_cs>`,
  login_adult_verify_popup: `ผลงานนี้มีเนื้อหาที่ไม่เหมาะสมกับเยาวชน
ผู้ที่มีอายุ 18 ขึ้นไปเท่านั้นสามารถอ่านได้
คุณมีอายุ 18 ปีขึ้นไป ใช่หรือไม่?`,
  error_code_3000_toast: `กรุณาเข้าสู่ระบบอีกครั้งเพื่อต่ออายุข้อมูลการรับรองความถูกต้องของ`,
  login_blocked_toast: `คุณพยายามเข้าสู่ระบบหลายครั้งเกินไป เพื่อป้องกันบัญชีของคุณ มีการระงับชั่วคราวเมื่อเข้าสู่ระบบ โปรดลองอีกครั้งในภายหลัง`,
  login_global_withdraw_consent_popup_title: `นี่คือบัญชีสำหรับการเพิกถอนความยินยอมตามข้อกำหนดและเงื่อนไข`,
  login_global_withdraw_consent_popup_content: `นี่คือบัญชีที่ข้อตกลงในข้อกำหนดและเงื่อนไขถูกเพิกถอนเนื่องจากคำขอของผู้ใช้ คุณจะออกจากระบบ และคุณจะต้องยอมรับข้อกำหนดอีกครั้งเมื่อเข้าสู่ระบบ`,
  login_global_reconsent_title: `โปรดยอมรับข้อกำหนดและเงื่อนไข
ในการใช้งาน Kakao Webtoon `,
  authentication_global_popup_title: `กรุณาใส่วันเดือนปีเกิดของคุณเพื่ออ่าน`,
  authentication_global_popup_content: `ผลงานนี้มีเนื้อหาที่ไม่เหมาะสำหรับเยาวชน ดังนั้นจึงสามารถเข้าอ่านได้เฉพาะผู้ที่มีอายุ 18 ปีขึ้นไปเท่านั้น โปรดกรอกวันเกิดของคุณเพื่อยืนยันอายุ`,
  authentication_global_adult_toast: `ต้องมีอายุ 18 ปีขึ้นไป`,
  authentication_global_succeed_adult_toast: `ยืนยันอายุเป็น {{n}} ปี`,
  authentication_global_failed_adult_toast: `ผลงานนี้มีไว้สำหรับอายุ 18 ปีขึ้นไปเท่านั้น`,
  authentication_global_confirm_popup_content: `วันเดือนปีเกิดที่คุณกรอกคือ {{value}} ต้องการยืนยันตามนี้หรือไม่`,
  luckydraw_title_slot: `สล็อตแมชชีน`,
  luckydraw_title_box: `ของขวัญนำโชค`,
  luckydraw_title_web: `สล็อตแมชชีน`,
  luckydraw_start: `เริ่ม`,
  luckydraw_win: `คุณได้รับรางวัล`,
  luckydraw_win_prize: `คุณได้รับรางวัล`,
  luckydraw_participated: `คุณเคยเข้าร่วมแล้ว`,
  luckydraw_winning_gift: `ของขวัญ`,
  luckydraw_date_received: `วันที่ได้รับ`,
  luckydraw_expiry: `หมดอายุ`,
  luckydraw_expiry_date: `{{count}} วัน นับจากวันที่แจก`,
  luckydraw_expiry_date_plural: `{{count}} วัน นับจากวันที่แจก`,
  luckydraw_expiry_hour: `{{count}} ชม. นับจากวันที่แจก`,
  luckydraw_expiry_hour_plural: `{{count}} ชม. นับจากวันที่แจก`,
  luckydraw_expiry_specific: `จนถึง {{value}}`,
  luckydraw_expiry_today: `หมดอายุ: ภายในวันนี้`,
  luckydraw_expiry_hour_1: `หมดอายุ: 59น.นับจากเวลาแจ้งเตือน `,
  luckydraw_expired: `สิ้นสุดระยะเวลาเข้าร่วม
สล็อตแมชชีน`,
  luckydraw_expired_box: `สิ้นสุดระยะเวลาเข้าร่วม
กล่องของขวัญนำโชค`,
  luckydraw_win_cash: `คุณได้รับแคช`,
  luckydraw_win_cash_amount: `ได้รับรางวัล {{value}} แคช`,
  luckydraw_ticket_title: `ชื่อเรื่อง`,
  luckydraw_win_ticket_amount: `ได้รับรางวัล {{count}} ตั๋วของขวัญ`,
  luckydraw_win_ticket_amount_plural: `ได้รับรางวัล {{count}} ตั๋วของขวัญ`,
  luckydraw_prize_notice: `ข้อควรระวัง`,
  luckydraw_prize_notice_1: `แคชที่เติมสำเร็จแล้ว ไม่สามารถทำการขอคืนเงินได้ทุกกรณี`,
  luckydraw_prize_notice_2_specific: `หากไม่ใส่ข้อมูลส่วนตัวภายใน {{date}}
คุณอาจถูกยกเลิกสิทธิ์การได้รับรางวัล`,
  luckydraw_prize_notice_2: `หากไม่ใส่ข้อมูลส่วนตัวภายในอีก {{date}}
คุณอาจถูกยกเลิกสิทธิ์การได้รับรางวัล`,
  luckydraw_prize_notice_3: `ทีมงานจะติดต่อเพื่อตรวจสอบข้อมูลส่วนตัว 
หากไม่สามารถติดต่อได้หรือแจ้งเบอร์ติดต่อผิด คุณอาจถูกยกเลิกสิทธิ์การได้รับรางวัล`,
  luckydraw_global_enterinfo: `ใส่ข้อมูลสำหรับการรับรางวัล`,
  luckydraw_global_title: `ใส่ข้อมูลเพื่อรับรางวัล`,
  luckydraw_global_enterinfo_prize: `กรุณาใส่ข้อมูลเพื่อรับรางวัล {{prize}}`,
  luckydraw_global_enterinfo_placeholder: `กรุณากรอกข้อมูลของคุณ`,
  luckydraw_global_enterinfo_button_submit: `ส่ง`,
  luckydraw_global_enterinfo_button_expired: `หมดอายุ`,
  luckydraw_global_enterinfo_button_submitted: `ส่งสำเร็จ`,
  luckydraw_global_entered_popup: `บันทึกข้อมูลการรับของรางวัลแล้ว`,
  crm_ticker_button: `วันนี้เช็กหรือยัง?`,
  crm_bottom_event_period: `ระยะเวลากิจกรรม`,
  crm_bottom_reward_title: `แจกรางวัล`,
  crm_bottom_notice: `ข้อควรระวัง`,
  crm_comment_button: `เขียนความคิดเห็น`,
  crm_comment_count: `ดู {{count}} ความคิดเห็นเพิ่มเติม`,
  crm_comment_count_plural: `ดู {{count}} ความคิดเห็นเพิ่มเติม`,
  crm_advance_reservation_button: `กดติดตาม`,
  crm_advance_reservation_toast: `กดติดตามสำเร็จ`,
  crm_advance_reservation: `กดติดตาม`,
  crm_advance_reservation_button_v4: `ลงทะเบียน`,
  crm_attendance_status_count: `เช็กชื่อ {{count}}/{{max}}`,
  crm_attendance_status_not_participated: `พร้อมแล้ว`,
  crm_attendance_status_participating: `กำลังดำเนินการ`,
  crm_attendance_status_participated: `เข้าร่วมสำเร็จ`,
  crm_attendance_status_toast: `เช็กชื่อสำเร็จ`,
  crm_attendance_status_day: `เช็กชื่อครั้งที่ {{value}}`,
  crm_attendance_status_day_v4: `เช็กชื่อครั้งที่ {{value}}`,
  crm_attendance_status_day_short: `เช็กชื่อครั้งที่ {{value}}`,
  crm_attendance_reward_slot_ticket: `แจกสล็อตแมชชีนทันที!`,
  crm_attendance_reward_gift_ticket: `แจกตั๋วของขวัญ!`,
  crm_attendance_reward_cash: `แจก {{value}} แคช!`,
  crm_attendance_button_before: `เช็กชื่อ`,
  crm_attendance_button_complete: `เช็กชื่อสำเร็จ`,
  crm_attendance_advance_register: `ลงทะเบียนล่วงหน้า`,
  crm_attendance_advance_register_button: `ลงทะเบียน`,
  crm_attendance_advance_registered_toast: `ลงทะเบียนล่วงหน้าสำเร็จ`,
  crm_attendance_advance_register_button_before: `ลงทะเบียนล่วงหน้า`,
  crm_attendance_advance_register_button_after: `ลงทะเบียนล่วงหน้าสำเร็จ`,
  crm_push_mission_title: `กดเปิด PUSH ก่อนเล่นกิจกรรม`,
  crm_push_mission_content: `ปุ่มเดียวจบ ได้รับข้อมูลครบ
ไม่พลาดทุกกิจกรรม ตอนใหม่ และอื่นๆ`,
  crm_push_on_toast: `ตั้งค่ารับการแจ้งเตือน PUSH สำเร็จแล้ว`,
  crm_push_on: `เปิดการแจ้งเตือน PUSH`,
  crm_push_on_button: `ON`,
  crm_fav_notification_popup_title: `เพิ่มในผลงานที่ติดตามแล้ว`,
  crm_fav_notification_popup_content: `รับการแจ้งเตือนเมื่อผลงานมีอัปเดต
ตั้งค่าได้ที่ 'ชั้นหนังสือ > ผลงานที่ติดตาม'`,
  crm_recommend_not_sale: `ผลงานนี้ยังไม่เปิดตัว โปรดลองอีกครั้งในภายหลัง`,
  crm_quiz_before_enter: `โปรดป้อนคำตอบที่ถูกต้อง`,
  crm_quiz_submit_button: `ส่งคำตอบ`,
  crm_quiz_submit_complete_button: `ส่งคำตอบเสร็จแล้ว`,
  crm_quiz_correct_answer_popup: `คำตอบถูกต้อง!
{{reward}} เข้าบัญชีแล้ว`,
  crm_quiz_correct_answer_raffle_popup: `คำตอบถูกต้อง!
การสมัครเสร็จสมบูรณ์`,
  crm_quiz_incorrect_answer_popup: `ไม่ใช่คำตอบที่ถูกต้อง
กรุณาลองอีกครั้ง`,
  crm_quiz_hint: `HINT`,
  crm_quiz_answer_exceed_toast: `ตัวอักษรเกินจำนวนจำกัดที่สามารถเขียนได้
`,
  crm_share_button: `กดแชร์กิจกรรม`,
  share_invitation_code_popup: `แชร์รหัสเชิญกันตอนนี้เลย`,
  special_title: `พิเศษ`,
  mainhome_special_contenthome_button: `ไปอ่านเว็บตูน`,
  mainhome_popup_version_update_mandatory_title: `แจ้งการอัปเดตที่จำเป็น`,
  mainhome_popup_version_update_mandatory_content: `จำเป็นต้องอัปเดตเวอร์ชั่นใหม่ เพื่อการใช้งาน KAKAO WEBTOON ฟังก์ชั่นที่ปรับปรุงใหม่และเสถียรขึ้น การอัปเดตจะใช้เวลาประมาณหนึ่งนาทีและสามารถใช้บริการได้ทันทีหลังอัปเดตสำเร็จ`,
  mainhome_popup_version_update_optional_title: `แจ้งการอัปเดต`,
  mainhome_popup_version_update_optional_content: `เมื่ออัปเดตเป็นเวอร์ชั่นล่าสุด คุณจะสามารถใช้งานฟังก์ชั่นของ KAKAO WEBTOON ที่เสถียรขึ้น  การอัปเดตจะใช้เวลาประมาณหนึ่งนาทีและสามารถใช้บริการได้ทันทีหลังอัปเดตสำเร็จ`,
  mainhome_popup_permission_title: `แจ้งสิทธิ์การใช้งานแอป KAKAO WEBTOON`,
  mainhome_popup_permission_content: `ตั้งค่าสิทธิ์ต่างๆ ที่จำเป็นต้องเข้าถึงขณะใช้งานแอป`,
  mainhome_popup_version_keep_button: `ใช้เวอร์ชั่นปัจจุบัน`,
  mainhome_popup_version_exit_button: `จบการทำงาน`,
  mainhome_popup_participate_button: `เข้าร่วม`,
  mainhome_popup_dontshow_button: `ไม่แสดงอีก`,
  mainhome_popup_view_detail_button: `ดูรายละเอียด`,
  mainhome_popup_more_button: `ดูเพิ่มเติม`,
  error_server_toast: `เรียกข้อมูลมาไม่สำเร็จ`,
  error_server_popup_request: `จัดการคำขอไม่สำเร็จ กรุณาลองใหม่อีกครั้ง`,
  mainhome_popup_idfa_ko: `"หากเลือก 'อนุญาต' จะช่วยลดโฆษณาที่ไม่จำเป็น
และแสดงเฉพาะโฆษณาที่เหมาะสมกับ
ความสนใจของคุณเท่านั้น
หากไม่อนุญาตการติดตาม โฆษณาจะถูกแสดงแบบสุ่ม"
`,
  mainhome_popup_idfa_global: `ข้อมูลของคุณจะถูกจัดเพื่อมอบประสบการณ์โฆษณาที่ดี
และมีความเป็นส่วนตัวมากยิ่งขึ้น`,
  mainhome_display_mode_popup_title: `ตอนนี้คุณสามารถเลือกโหมดหน้าจอได้แล้ว ลองใช้เลย!`,
  mainhome_display_mode_popup_content: `คุณสามารถเลือกโหมดหน้าจอที่ต้องการได้ระหว่างโหมดมืดและโหมดสว่าง`,
  mainhome_display_mode_popup_button: `ไปที่การตั้งค่า`,
  badge_new: `N`,
  badge_up: `UP`,
  badge_today: `วันนี้`,
  badge_new_season: `N`,
  badge_ongoing: `ยังไม่จบ`,
  badge_completed: `จบ`,
  badge_hiatus: `หยุด`,
  badge_completed_season: `จบซีซั่น`,
  badge_brand: `แบรนด์เว็บตูน`,
  badge_alive: `ALIVE`,
  badge_mon: `จ.`,
  badge_tue: `อ.`,
  badge_wed: `พ.`,
  badge_thu: `พฤ.`,
  badge_fri: `ศ.`,
  badge_sat: `ส.`,
  badge_sun: `อา.`,
  badge_not_available: `ยกเลิกการขาย`,
  badge_mon_long: `จ.`,
  badge_tue_long: `อ.`,
  badge_wed_long: `พ.`,
  badge_thu_long: `พฤ.`,
  badge_fri_long: `ศ.`,
  badge_sat_long: `ส.`,
  badge_sun_long: `อา.`,
  badge_free: `ฟรี`,
  badge_rent: `เช่า`,
  badge_possess: `ซื้อเก็บ`,
  badge_comment_creator: `CREATOR`,
  badge_comment_best: `BEST`,
  onboarding_next_button: `ถัดไป`,
  onboarding_start_button: `เริ่ม`,
  onboarding_start_without_login: `เริ่มโดยไม่ต้องเข้าสู่ระบบ`,
  onboarding_start: `สวัสดี ยินดีต้อนรับสู่ KAKAO WEBTOON`,
  onboarding_skip_popup_title: `เดี๋ยวก่อน! Welcome Voucher กำลังรอคุณอยู่!`,
  onboarding_skip_popup_content: `สมัครสมาชิกตอนนี้ รับตั๋วของขวัญ อ่านเว็บตูนแนะนำฟรี!`,
  onboarding_skip_comfirm: `ไปหน้าแรก`,
  onboarding_genre_title: `เลือกประเภทที่ชอบ เพื่อรับการแนะนำที่เหมาะกับคุณ`,
  onboarding_content_title: `ยินดีด้วย! คุณได้รับตั๋วของขวัญ อ่านฟรี KAKAO WEBTOON `,
  bridgepage_description: `พบกับเว็บตูนที่ปลุกจินตนาการของคุณที่ Kakao Webtoon`,
  bridgepage_web_button: `ดำเนินการต่อในเว็บฯ`,
  bridgepage_app_button: `ดำเนินการต่อในแอปฯ`,
  bridgepage_language_change: `เกิดข้อผิดพลาด เนื่องจากการเปลี่ยนแปลงตั้งค่าภาษา
`,
  error_network_popup_ios: `ไม่สามารถเปิดแอปได้ กรุณาลองอีกครั้ง`,
  offline_no_connection_popup: `คุณไม่ได้เชื่อมต่อกับเครือข่าย
คุณต้องการใช้ในโหมดออฟไลน์หรือไม่`,
  offline_no_connection_popup_exit_button: `ออกจากแอป`,
  error_api_call_toast: `จัดการคำขอไม่สำเร็จ 
กรุณาลองใหม่อีกครั้ง`,
  offline_enter_button: `เข้าสู่โหมดออฟไลน์`,
  offline_no_connection_toast: `ไม่ได้เชื่อมต่อเครือข่าย 
กรุณาตรวจสอบการเชื่อมต่อเครือข่าย`,
  offline_convert_online_popup: `เชื่อมต่อเครือข่ายแล้ว 
ต้องการเปลี่ยนเป็นโหมดออนไลน์หรือไม่?`,
  offline_enter_online_mode: `โหมดออนไลน์`,
  offline_download_tab_title: `ดาวน์โหลด`,
  offline_rental_expired_toast: `ตั๋วเช่าหมดอายุแล้ว`,
  error_region_unmatch_app_popup: `แอปพลิเคชันไม่สามารถใช้งานได้ ณ ประเทศของคุณ
โปรดติดตั้งใหม่อีกครั้ง และสมัครสมาชิกโดยเลือกเป็นประเทศที่คุณเคยสมัครในแอปฯ นี้
`,
  error_region_unmatch_web_popup: `แอปพลิเคชันไม่สามารถใช้งานได้ ณ ประเทศของคุณ
โปรดสมัครสมาชิกโดยเลือกเป็นประเทศที่คุณเคยสมัครในเว็บไซต์นี้
`,
  error_server_common_toast: `เกิดข้อผิดพลาด โปรดลองอีกครั้งในภายหลัง`,
  error_server_duplicate_request_toast: `กำลังดำเนินการคำร้องขอ`,
  error_version_popup_contents: `ฟังก์ชั่นนี้ไม่รองรับในเวอร์ชั่นปัจจุบัน
กรุณาอัปเดตที่ App Store เพื่อใช้งาน`,
  error_page_not_found: `ไม่พบหน้าดังกล่าว`,
  error_not_found: `ไม่พบหน้าที่คุณร้องขอ`,
  block_service_check_title: `แจ้งการปรับปรุงระบบ`,
  block_service_check_content: `เพื่อการมอบบริการที่รวดเร็วและเสถียรยิ่งขึ้น 
จึงจะมีการปิดปรับปรุงระบบ ขออภัยในความไม่สะดวก และเราสัญญาว่าจะทำเต็มที่เสมอเพื่อการบริการที่ดี 
ขอขอบคุณมา ณ ที่นี้`,
  block_service_check_date_range: `ระยะเวลา: {{start}} ~ {{end}}`,
  error_event_expired_popup: `สิ้นสุดระยะเวลากิจกรรมแล้ว`,
  error_event_expired_toast: `ไม่สามารถเข้าร่วมกิจกรรมได้เพราะสิ้นสุดระยะเวลาแล้ว`,
  error_event_participate_popup: `ไม่สามารถเข้าร่วมกิจกรรมได้`,
  error_cash_fail_aos: `เกิดข้อผิดพลาดที่ Google Play ขณะดำเนินการชำระเงิน
กรุณาลบดาต้าและแคชทั้งหมดของ Google play store app
หรือยกเลิกสินค้าที่รอดำเนินการในประวัติการซื้อของ Google play store
แล้วลองดำเนินการใหม่อีกครั้ง`,
  error_cash_fail_aos_button: `ลบจากการตั้งค่า`,
  android_tampering_popup_title: `ตรวจพบการปลอมแปลงแอปฯ บริการจึงถูกยกเลิก`,
  android_tampering_popup_content: `หากเกิดปัญหาเดียวกันหลังจากถอนการติดตั้งแอปฯ และติดตั้งใหม่ผ่านสโตร์ โปรดติดต่อมาที่ Inbox Facebook Page Kakao Webtoon`,
  android_error_connection: `ไม่สามารถโหลดเพจได้ กรุณาตรวจสอบการเชื่อมต่อและเข้าใหม่`,
  android_error_temporary: `ไม่สามารถโหลดเพจได้เนื่องจากพบปัญหาชั่วคราว`,
  android_error_webview: `พบปัญหาเกิดขึ้นในเว็บวิว กรุณาเปิดแอปใหม่`,
  js_alert_leave_title: `ยืนยันการสำรวจ`,
  leave_this_page: `ออกจากหน้านี้`,
  stay_this_page: `อยู่ในหน้านี้ต่อไป`,
  question_leave_this_page: `ต้องการออกจากหน้านี้หรือไม่?`,
  ssl_warnings_header: `เกิดข้อผิดพลาดที่ใบรับรองความปลอดภัยของเว็บไซต์`,
  ssl_continue: `ทำต่อ`,
  security_warning: `แจ้งเตือนความปลอดภัย`,
  view_certificate: `ดูใบรับรอง`,
  ssl_go_back: `ย้อนกลับ`,
  android_back_button_quit_toast: `กดย้อนกลับอีกครั้งเพื่อปิดแอป`,
  ssl_untrusted: `ไม่ใช่แหล่งใบรับรองที่น่าเชื่อถือได้`,
  ssl_mismatch: `ชื่อเว็บไซต์ไม่ตรงกับในใบรับรอง`,
  ssl_expired: `ใบรับรองหมดอายุแล้ว`,
  ssl_not_yet_valid: `ไม่พบใบรับรองดังกล่าว`,
  ssl_date_invalid: `ใบรับรองยังไม่ถึงวันที่มีผล`,
  ssl_invalid: `ใบรับรองไม่ถูกต้อง`,
  ssl_unknown: `เกิดข้อผิดพลาดไม่ทราบสาเหตุที่ใบรับรอง`,
  ssl_certificate: `ใบรับรองความปลอดภัย`,
  ssl_certificate_is_valid: `ใบรับรองถูกต้อง`,
  page_info: `ข้อมูลเพจ`,
  page_info_view: `ดููข้อมูลเพจ`,
  page_info_address: `ที่อยู่:`,
  issued_to: `ออกให้:`,
  common_name: `ชื่อสามัญ:`,
  org_name: `ชื่อองค์กร:`,
  org_unit: `ขนาดองค์กร:`,
  issued_by: `ออกโดย:`,
  validity_period: `ประเภท:`,
  issued_on: `วันที่ออกให้:`,
  expires_on: `วันที่หมดอายุ:`,
  serial_number: `หมายเลขซีเรียล:`,
  sha256_fingerprint: `ลายนิ้วมือ SHA-256:`,
  sha1_fingerprint: `ลายนิ้วมือ SHA-1:`,
  message_webview_certificate_transparency: `กรุณาอัปเดตแอปที่เกี่ยวข้องกับ Web View เพื่อแก้ปัญหาเรื่องใบรับรองความปลอดภัย`,
  popup_window_attempt: `อนุญาตให้เปิดหน้าต่างป็อบอัปบนเว็บไต์นี้หรือไม่?`,
  webview_allow: `อนุญาต`,
  webview_block: `บล็อก`,
  webview_update: `อัปเดต`,
  webview_ok: `ตกลง`,
  webview_cancel: `ยกเลิก`,
  webview_login: `เข้าสู่ระบบ`,
  js_alert_title: `เนื้อหาเพจ '{{value}}' :`,
  notification_category_download: `แจ้งเตือนการดาวน์โหลด`,
  notification_category_common: `แจ้งเตือนทั่วไป`,
  notification_channel_download: `อนุญาตแจ้งเตือนเมื่อดาวน์โหลดอีพี`,
  notification_channel_common: `อนุญาตแจ้งเตือนเมื่อมีข่าวสารเกี่ยวกับการอัปเดตตอนใหม่ รออ่านฟรี และกิจกรรม เป็นต้น`,
  android_battery_optimization_popup_contents: `หากคุณต้องการดาวน์โหลดตอน ในขณะที่ไม่ได้เปิดใช้แอปฯ คุณต้องปิดการตั้งค่าแอปฯ Kakao Webtoon จากโหมดเพิ่มประสิทธิภาพแบตเตอรี่`,
  multilingual_redeem_code_popup: `คูปองนี้ไม่สามารถใช้ได้สำหรับการตั้งค่าภาษาของคุณในตอนนี้`,
  footer_customer_service: `ติดต่อทีมงาน`,
  footer_business_info: `ข้อมูลผู้ให้บริการ`,
  footer_terms_of_use: `เงื่อนไขการใช้งาน`,
  footer_privacy: `นโยบายความเป็นส่วนตัว`,
  footer_inquiry: `ติดต่อทีมงาน`,
  footer_youth_protection: `นโยบายคุ้มครองเยาวชน`,
  footer_copyright: `© KAKAO WEBTOON`,
  footer_cookie_policy: `นโยบายคุกกี้`,
  region_unsupported_title: `แจ้งเกี่ยวกับประเทศที่ไม่รองรับ`,
  region_unsupported_content: `ประเทศของคุณที่เชื่อมต่ออยู่ 
ไม่รองรับกับบริการนี้ กรุณาเลือกประเทศที่จะใช้บริการ เมื่อเลือกประเทศแล้วจะไม่สามารถเปลี่ยนแปลงได้อีก`,
  region_unsupported_exit_button: `ออกจากแอป`,
  region_country_select: `เลือกประเทศที่จะใช้บริการ`,
  region_country_select_english: `English`,
  region_language_different_popup: `รีสตาร์ตแอปเพื่อการเปลี่ยนแปลงภาษาที่รองรับการใช้งานในประเทศปัจจุบัน`,
  region_restart_button: `รีสตาร์ต`,
  region_language_select_popup: `คุณจำเป็นต้องเปลี่ยนเป็นภาษาที่รองรับโดยประเทศปัจจุบันของคุณ โปรดเลือกภาษาที่จะใช้บริการ`,
  region_language_restart_toast: `โปรดเปิดแอปอีกครั้งเนื่องจากต้องเปลี่ยนภาษาที่รองรับโดยประเทศปัจจุบันของคุณ`,
  region_select_region_popup_title: `คำแนะนำในการเลือกประเทศที่คุณใช้งาน`,
  region_select_region_popup_title_v4: `คำแนะนำในการเลือกภาษาที่คุณใช้งาน`,
  region_select_region_popup_content: `โปรดเลือกประเทศที่คุณต้องการใช้บริการ \n หากคุณเลือกประเทศแล้ว จะไม่สามารถเปลี่ยนเป็นประเทศอื่นอีกได้`,
  region_select_region_popup_content_v4: `โปรดเลือกภาษาที่คุณต้องการใช้บริการ \n หากคุณเลือกภาษาแล้ว จะไม่สามารถเปลี่ยนเป็นภาษาอื่นอีกได้`,
  invitation_guest_welcome_popup_title: `ยินดีต้อนรับสู่ Kakao Webtoon`,
  invitation_guest_welcome_popup_content: `- ของขวัญคำเชิญจะมอบให้กับของกิจกรรมเท่านั้น
- คุณสามารถค้นหาข้อมูลโดยละเอียดเกี่ยวกับเป้าหมายของกิจกรรมได้ที่หน้ากล่องของขวัญ > กิจกรรม
- หากผู้ใช้ที่เชิญฉันและอุปกรณ์ของฉันเป็นคนเดียวกัน จะไม่มีการจ่ายของขวัญคำเชิญ`,
  invitation_host_status_count: `{{count}}/{{max}} คน ถูกชวน`,
  invitation_host_status_participating: `กำลังดำเนินการ`,
  invitation_host_status_participated: `เข้าร่วมสำเร็จ`,
  invitation_host_link_share_button: `แชร์ลิ้งก์การเชิญ`,
  invitation_host_link_share_popup_title: `แชร์`,
  invitation_host_link_share_popup_content: `แชร์รหัสเชิญกันตอนนี้เลย`,
  invitation_host_code_share_button: `คัดลอกรหัสเชิญ`,
  invitation_host_code_share_toast: `รหัสเชิญ : {{code}}
คัดลอกรหัสเชิญลงคลิปบอร์ดแล้ว`,
};